import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import './style.css';
import { useLocation } from 'react-router-dom';
import DynamicTable from '../../DynamicTable';
import probabilidade from '../../../img/probabilidade.png'

export function ConteudoPgr(props: any) {
    const [nomeResponsavel, setNomeResponsavel] = useState('');
    const [cargoResponsavel, setCargoResponsavel] = useState('');
    const [crmResponsavel, setCrmResponsavel] = useState('');
    const [registroResponsavel, setRegistroResponsavel] = useState('');
    const [nomeRevisao, setNomeRevisao] = useState('');
    const [vigenciaRevisao, setVigenciaRevisao] = useState('');
    const [historicoData, setHistoricoData] = useState<any[]>([]);
    const location = useLocation();
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1).toUpperCase();
    const [tabelaPadrao, setTabelaPadrao] = useState<any>(null);
    const [revisoes, setRevisoes] = useState([])
    let contador = 0;

    function getContador() {
        return String(contador++).padStart(2, '0');
    }

    useEffect(() => {
        const fetchTabelaPadrao = async () => {
            try {
                const response = await api.get('buscar-tabela-padrao');
                setTabelaPadrao(response.data[0]);
            } catch (error) {
                console.error("Erro ao buscar a tabela padrão:", error);
            }
        };

        if (!tabelaPadrao) {
            fetchTabelaPadrao();
        }
    }, [tabelaPadrao]);

    function formatarDataRevisao(dataOriginal: string, anosParaAdicionar: number) {
        let data = new Date(dataOriginal);
        data.setFullYear(data.getFullYear() + anosParaAdicionar);
        return data.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' }).toUpperCase();
    }


    //Buscar Responsável
    const fetchResponsavel = async () => {
        try {
            const response = await api.get(`listar-responsavel-por-empresa/${props.props.idEmpresa}`);
            if (response && response.data) {
                setNomeResponsavel(response.data[0].nome);
                setCargoResponsavel(response.data[0].cargo);
                setCrmResponsavel(response.data[0].tipo_profissional);
                setRegistroResponsavel(response.data[0].registro_profissional);
            }
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        }
    };

    // Função para buscar o histórico
    const fetchHistorico = async () => {
        try {
            const response = await api.get(`listar-historico-documento/${props.props.idFdt}`);
            const responseData = response.data;

            const revisoesFiltradas = responseData.revisoes.filter(
                (rev: any) => rev.nome === 'Revisão' || !rev.id_emissao
            );

            const dadosFiltrados = responseData.historico
                .sort((a: any, b: any) => a.funcao.pgrGhe.nome.localeCompare(b.funcao.pgrGhe.nome));


            console.log(responseData.historico)
            console.log(dadosFiltrados)

            setHistoricoData(dadosFiltrados);
            setRevisoes(revisoesFiltradas);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        }
    };

    useEffect(() => {
        fetchHistorico();
        fetchResponsavel()
    }, [props.props.idRevisao, props.props.idEmpresa]);

    useEffect(() => {
        const obterNomeFdt = async () => {
            if (props.props.idRevisao) {
                try {
                    const response = await api.post(`listar-revisao/${props.props.idRevisao}/${props.props.idEmpresa}`);
                    if (response && response.data.revisao && response.data.revisao.length > 0) {
                        setNomeRevisao(response.data.revisao[0].nome);
                        const dataVigencia = formatarDataRevisao(response.data.revisao[0].expires_at, 0);
                        setVigenciaRevisao(dataVigencia);
                    }
                } catch (error) {
                    console.error('Erro ao obter o nome da FDT:', error);
                }
            }
        };
        obterNomeFdt();
    }, [props.props.idRevisao]);

    const getDataDeHoje = () => {
        const hoje = new Date();
        return hoje.toLocaleDateString('pt-BR');
    };
    const uniqueRevisoes = new Map();
    historicoData.forEach((item, index) => {
        if (!uniqueRevisoes.has(item.revisao.id)) {
            uniqueRevisoes.set(item.revisao.id, uniqueRevisoes.size + 1);
        }
    });

    function formatarDataISO(dataISO: string) {
        if (dataISO) {
            // A dataISO é assumida como estando no formato "YYYY-MM-DD"
            const partes = dataISO.split('-'); // Divide a string pela hifen
            // Reorganiza as partes para o formato "DD/MM/YYYY"
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }


    }
    //TODAS AS REVISÕES

    //IDENTIFICAÇÃO DA EMPRESA
    const [empresaId, setEmpresaId] = useState("");
    const [empresaRazaoSocial, setEmpresaRazaoSocial] = useState("");
    const [empresaCNPJ, setEmpresaCNPJ] = useState("");
    const [empresaEndereco, setEmpresaEndereco] = useState("");
    const [empresaEndNumero, setEmpresaEndNumero] = useState("");
    const [empresaCep, setEmpresaCep] = useState("");
    const [empresaBairro, setEmpresaBairro] = useState("");
    const [empresaCidade, setEmpresaCidade] = useState("");
    const [empresaEstado, setEmpresaEstado] = useState("");
    const [empresaTelefone, setEmpresaTelefone] = useState("");
    const [empresaCelular, setEmpresaCelular] = useState("");
    const [empresaEmail, setEmpresaEmail] = useState("");
    // const [empresaCei, setEmpresaCei] = useState("");
    const [empresaCnae, setEmpresaCnae] = useState("");
    const [empresaInscEstadual, setEmpresaIsncEstadual] = useState("");

    const [empresaRespNome, setEmpresaRespNome] = useState("");
    const [empresaRespEmail, setEmpresaRespEmail] = useState("");
    const [empresaRespCargo, setEmpresaRespCargo] = useState("");
    const [empresaRespTelefone, setEmpresaRespTelefone] = useState("");

    useEffect(() => {
        const buscarDadosEmpresa = async () => {
            try {
                const response = await api.get(`/empresas/listar/${props.props.idEmpresa}`);
                const empresa = response.data;
                setEmpresaId(empresa.id);
                setEmpresaRazaoSocial(empresa.nome);
                setEmpresaCNPJ(empresa.cnpj);
                setEmpresaEndereco(empresa.endereco)
                setEmpresaEndNumero(empresa.numero)
                setEmpresaCep(empresa.cep)
                setEmpresaBairro(empresa.bairro)
                setEmpresaCidade(empresa.cidade)
                setEmpresaEstado(empresa.estado)
                setEmpresaTelefone(empresa.telefone)
                setEmpresaCelular(empresa.celular)
                setEmpresaEmail(empresa.email)
                // setEmpresaCei(empresa.cei);
                setEmpresaCnae(empresa.cnae);
                setEmpresaIsncEstadual(empresa.insc_estadual);
                setEmpresaRespNome(empresa.resp_empresa_nome);
                setEmpresaRespEmail(empresa.resp_empresa_email);
                setEmpresaRespCargo(empresa.resp_empresa_cargo);
                setEmpresaRespTelefone(empresa.resp_empresa_telefone);
            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosEmpresa();
    }, [props.props.idEmpresa]);

    //DadosFdt
    const [fdtId, setFdtId]: any = useState("");
    const [fdtGrauRisco, setFdtGrauRisco]: any = useState("");
    useEffect(() => {
        const buscarDadosFdt = async () => {
            try {
                const response = await api.post(`listar-fdt/${props.props.idFdt}`, { id_empresa: props.props.idEmpresa });
                const fdt = response.data.fdt[0];
                setFdtId(fdt.id);
                setFdtGrauRisco(fdt.grau_risco);
            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosFdt();
    }, [props.props.idFdt]);

    //DADOS FUNCIONARIOS
    const [funcionarios, setFuncionarios]: any = useState([]);
    const [funcionariosTotal, setFuncionariosTotal]: any = useState("");

    useEffect(() => {
        const loadEmployees = async () => {
            try {
                const response = await api.post('funcionarios', { id_empresa: props.props.idEmpresa });
                console.log("🚀 ~ loadEmployees ~ response:", response.data)
                setFuncionarios(response.data)
                // setFuncionariosTotal(response.data.length);
            } catch (error) {
                console.error("Error fetching funcionarios:", error);
            }
        };
        loadEmployees()
    }, [props.props.idEmpresa]);

    // useEffect(() => {

    //     const handleListFunction = async (inputValue: any) => {
    //         const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
    //         const responseData = response.data;
    //     };
    //     handleListFunction('encanador')
    // }, [funcionariosTotal]);

    //DADOS DAS FUNÇÕES
    const [funcoes, setFuncoes] = useState([]);
    const [uniqueGHEs, setUniqueGHEs] = useState([]);
    const [riscos, setRiscos] = useState([]);
    const [acoesCronograma, setAcoesCronograma]: any = useState([]);
    const [intervalosCronograma, setIntervalosCronograma] = useState([]);


    useEffect(() => {
        const fetchFuncoesERiscos = async () => {
            try {

                // const responsTabela = await api.get('buscar-tabela-padrao');

                // const tabela = responsTabela.data[0];

                // setTipo(tabela.tipo);
                // setCor(tabela.cor);

                const response = await api.post('listar-pgr', {
                    id_empresa: props.props.idEmpresa,
                    id_fdt: props.props.idFdt,
                    id_revisao: props.props.idRevisao,
                    id_ghe: props.props.idGhe,
                    tipo_documento: routeName
                });

                // Ordenar as funções pelo nome do GHE em ordem crescente
                const funcoesOrdenadas = response.data.funcoes.sort((a: any, b: any) => {
                    const nomeA = a.pgrGhe.nome.toUpperCase();
                    const nomeB = b.pgrGhe.nome.toUpperCase();
                    if (nomeA < nomeB) {
                        return -1;
                    }
                    if (nomeA > nomeB) {
                        return 1;
                    }
                    return 0;
                });
                console.log("🚀 ~ funcoesOrdenadas ~ response.data.funcoes:", response.data.funcoes)

                setFuncoes(funcoesOrdenadas);
                setAcoesCronograma(response.data.acoes_cronograma);
                setIntervalosCronograma(response.data.intervalo_cronograma);

                // Alteração aqui: armazene objetos com id e nome
                const ghes = Array.from(new Set(funcoesOrdenadas.map((funcao: any) => ({
                    id: funcao.pgrGhe.id,
                    nome: funcao.pgrGhe.nome
                }))));

                // Esta lógica garante a unicidade dos GHEs pelo id, mantendo o último nome encontrado
                const uniqueGhesMap: any = new Map(ghes.map((ghe: any) => [ghe.id, ghe]));
                setUniqueGHEs(Array.from(uniqueGhesMap.values()));

                const riscosFiltrados = response.data.riscos.filter((risco: any) => uniqueGhesMap.has(risco.id_ghe));
                setRiscos(riscosFiltrados);

                const totalFuncionarios = funcoesOrdenadas.reduce((total: number, funcao: any) => {
                    return total + funcao.num_tra_masc + funcao.num_tra_fem;
                }, 0);

                setFuncionariosTotal(totalFuncionarios);
            } catch (error) {
                console.error('Erro ao buscar GHEs:', error);
            }
        };

        fetchFuncoesERiscos();
    }, [props.props.idEmpresa, props.props.idFdt, props.props.idRevisao, props.props.idGhe]);


    const filtrarRiscosPorGHE = (idGhe: any) => {
        return riscos
            .filter((risco: any) => risco.id_ghe === idGhe)
            .reduce((acc: any[], risco: any) => {
                if (!acc.some(item => item.risco === risco.risco && item.categoria === risco.categoria)) {
                    acc.push(risco);
                }
                return acc;
            }, []);
    };

    const agruparFuncoesPorGHE = (gheId: any) => funcoes.filter((funcao: any) => funcao.pgrGhe.id === gheId);

    const renderizarFuncoes = (funcoesPorGHE: any) => {
        let linhasDeFuncoes = [];
        for (let i = 0; i < funcoesPorGHE.length; i += 4) {
            let funcoesSubconjunto = funcoesPorGHE.slice(i, i + 4);
            while (funcoesSubconjunto.length < 4) {
                funcoesSubconjunto.push({ AteBaseFuncao: { nome: "-" } });
            }
            linhasDeFuncoes.push(
                <div className="table-tr inv-fun" key={`funcoes-${i}`}>
                    <div className='table-td th'>FUNÇÕES</div>
                    {funcoesSubconjunto.map((funcao: any, index: any) => (
                        <div className='table-td' key={`funcao-${index}`}>{funcao.AteBaseFuncao.nome}</div>
                    ))}
                </div>
            );
        }
        return linhasDeFuncoes;
    };
    function mapearValorParaDescricao(valor: string) {
        if (valor === "Baixa") return '1';
        if (valor === "Média") return '2';
        if (valor === "Alta") return '3';
        if (valor === "Muito Alta") return '4';
        return "N/A"; // Caso o valor não esteja no intervalo esperado
    }
    function gerarGrauDeRisco(probabilidade: any, severidade: any): string {
        if (probabilidade == null || severidade == null) {
            return "Dados insuficientes";
        }

        const descricaoProbabilidade = mapearValorParaDescricao(probabilidade);
        const descricaoSeveridade = mapearValorParaDescricao(severidade);

        if (!descricaoProbabilidade || !descricaoSeveridade) {
            return "Valores não mapeáveis";
        }

        return `P${descricaoProbabilidade} x S${descricaoSeveridade}`;
    }

    //DADOS DA CIPA
    const [gpCipa, setGpCipa]: any = useState([]);
    const [atividadeCipa, setAtividadeCipa]: any = useState([]);

    const formatCnae = (cnae: any) => {

        let cleanCnae = cnae.replace(/[^\d]/g, '');
        return `${cleanCnae.slice(0, 2)}.${cleanCnae.slice(2, 4)}-${cleanCnae.slice(4, 5)}`;
    };

    const fetchCipa = async () => {
        try {
            if (empresaCnae) {
                const formattedCnae = formatCnae(empresaCnae);
                const response = await api.post(`listar-cipa/${formattedCnae}`);
                setGpCipa(response.data[0].gp_cipa);
                setAtividadeCipa(response.data[0].atividade);
            }
        } catch (error) {
            console.error('Erro ao buscar GHEs:', error);
        }
    };

    useEffect(() => {
        fetchCipa();
    }, [props.props.idEmpresa, empresaCnae]);

    //DADOS DA DIMENSIONAMENTO CIPA
    const [dimensionamentoCipa, setDimensionamentoCipa]: any = useState([]);

    const fetchDimensionamentoCipa = async () => {
        try {
            if (gpCipa) {
                const response = await api.post(`listar-dimensionamento-cipa/${gpCipa}`);
                setDimensionamentoCipa(response.data)
            }
        } catch (error) {
            console.error('Erro ao buscar GHEs:', error);
        }
    };

    useEffect(() => {
        fetchDimensionamentoCipa()
    }, [props.props.idEmpresa, gpCipa])

    const [datasExibidas, setDatasExibidas] = useState(new Set());

    //Cronograma

    const meses: any = {
        Jan: "Jan",
        Feb: "Fev",
        Mar: "Mar",
        Apr: "Abr",
        May: "Maio",
        Jun: "Jun",
        Jul: "Jul",
        Aug: "Ago",
        Sep: "Set",
        Oct: "Out",
        Nov: "Nov",
        Dec: "Dez",
    };

    const formatarIntervaloExecucoes = (intervalo: any) => {
        const [mesEn, ano]: any = intervalo.split('/');
        const mesPt = meses[mesEn.trim()] || mesEn;
        return `${mesPt.trim()} / ${ano.trim()}`;
    };

    const RenderizarRiscos = ({ gheId }: any) => {
        const [riscosFiltrados, setRiscosFiltrados]: any = useState([]);

        useEffect(() => {
            const riscosFiltradosData = filtrarRiscosPorGHE(gheId);
            setRiscosFiltrados(riscosFiltradosData);
        }, [gheId]);

        console.log(riscosFiltrados)

        if (!tabelaPadrao) {
            return <div>Carregando...</div>;
        }

        if (riscosFiltrados.length > 0) {
            return (
                <DynamicTable
                    type={tabelaPadrao.tipo}
                    headerColor={tabelaPadrao.cor}
                    riscos={riscosFiltrados}
                    edit={false}
                />
            );
        } else {
            return (
                <div className="table-tr inv-props">
                    <div className='table-td f-100'>Nenhum risco encontrado para o GHE selecionado.</div>
                </div>
            );
        }
    };


    return (
        <>
            <div className='table-div history'>
                <div className='setor' style={{ marginBottom: '10px' }}>
                    <div>Setor: ENGENHARIA DE SEGURANÇA</div>
                    <div>Elaborado Por: MAURICIO CHERATZKI</div>
                    <div>Data: {getDataDeHoje()}</div>
                    <div>Engenharia de Segurança do Trabalho - Atento</div>
                    <div>Responsável técnico: {nomeResponsavel} - {registroResponsavel}</div>
                    <div><b>Vigência: {vigenciaRevisao}</b></div>
                </div>
                <div className="table-tr" style={{ borderTop: '1px solid #000' }}>
                    <div className="table-td th">HISTÓRICO DE REVISÃO</div>
                </div>

                <div className='table-tr cab'>
                    <div className='table-td th'>Revisão</div>
                    <div className='table-td th'>Oficialização</div>
                    <div className='table-td th'>Descrição da Revisão</div>
                </div>

                {historicoData.length > 0 ? (
                    <>
                        {revisoes.map((revisao: any) => (
                            <React.Fragment key={revisao.id}>
                                <div className='table-div hist'>
                                    <div className='table-tr cab'>
                                        <div className='table-td'>{getContador()}</div>
                                        <div className='table-td'>{new Date(revisao.created_at).toLocaleDateString('pt-BR')}</div>
                                        <div className='table-td'>{revisao.nome}</div>
                                    </div>
                                </div>

                                {historicoData
                                    .filter(item => item.id_revisao === revisao.id && revisao.nome === 'Revisão')
                                    .map((item) => (
                                        <div key={item.id} className='table-div hist'>
                                            <div className='table-tr cab'>
                                                <div className='table-td'>{String(contador - 1).padStart(2, '0')}</div>
                                                <div className='table-td'>{new Date(item.revisao.created_at).toLocaleDateString('pt-BR')}</div>
                                                <div className='table-td'>
                                                    {`Função de ${item.funcao.AteBaseFuncao.nome} no ${item.funcao.pgrGhe.nome}`}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <div className='table-tr cab'>
                        <div className='table-td-data' style={{ flex: '0 0 100% !important', textAlign: 'center' }}>Sem dados!</div>
                    </div>
                )}


            </div >
            <div className='tituloCap' data-new-page="true" data-sum>1. INTRODUÇÃO AO PROGRAMA DE GERENCIAMENTO DE RISCOS</div>
            <div className='paragraph'>Em 08 de junho de 1978, a Portaria N.º 3214, aprovou o texto da original Norma Regulamentadora NR-1
                nomeada apenas como DISPOSIÇÕES GERAIS. Com sua última alteração aplicada pela Portaria SEPRT nº 915, de
                30/07/2019, inicialmente a respectiva norma estruturada em 11 páginas, estabelece as disposições gerais, o
                campo de aplicação, os termos e as definições comuns às Normas Regulamentadoras - NR relativas à segurança
                e saúde no trabalho.
            </div>
            <div className='paragraph'>
                Durante a 51ª reunião da Comissão Tripartite Paritária Permanente (CTPP), em outubro de 2007, por solicitação
                da bancada de trabalhadores, foi decidida a inclusão do tema gerenciamento de riscos ocupacionais na agenda
                da CTPP, visando solucionar problema regulatório advindo da revisão de 1994 da Norma Regulamentadora NR9, que instituiu o PPRA,
                como programa condicionado aos agentes físicos, químicos e biológicos. Durante a 64ª
                reunião da CTPP, em março de 2011, foi decidida a criação de Grupo de Estudos Tripartite - GET para inclusão
                na NR 1 de requisitos para gerenciamento de riscos ocupacionais, originando então em 9 de março de 2020 uma
                inovadora redação para a NR 1, nomeada então de DISPOSIÇÕES GERAIS E GERENCIAMENTO DE RISCOS
                OCUPACIONAIS.
            </div>
            <div className='paragraph'>
                Estruturada em 16 páginas, o novo texto da NR 1, estabelece as disposições gerais, o campo de aplicação, os
                termos e as definições comuns às Normas Regulamentadoras - NRs relativas à segurança e saúde no trabalho,
                as diretrizes e os requisitos para o gerenciamento de riscos ocupacionais e as medidas de prevenção em
                Segurança e Saúde no Trabalho – SST.
            </div>
            <div className='paragraph'>
                O gerenciamento de riscos ocupacionais constitui um Programa de Gerenciamento de Riscos – PGR contendo
                inventário de riscos e plano de ação, implementado por unidade operacional, setor ou atividade, integrando-se
                com planos, programas e outros documentos previstos na legislação de segurança e saúde no trabalho. Os dados
                da identificação dos perigos e das avaliações dos riscos ocupacionais devem ser consolidados em um inventário
                de riscos ocupacionais, com elaboração de plano de ação, indicando as medidas de prevenção a serem
                introduzidas, aprimoradas ou mantidas com cronograma, formas de acompanhamento e aferição de resultados.
                Ainda em observância à esta NR, a organização deve analisar os acidentes e as doenças relacionadas ao trabalho,
                considerando as situações geradoras dos eventos, levando em conta as atividades efetivamente desenvolvidas,
                ambiente de trabalho, materiais e organização da produção e do trabalho; identificar os fatores relacionados
                com o evento; e fornecer evidências para subsidiar e revisar as medidas de prevenção existentes. A organização
                também deve estabelecer, implementar e manter procedimentos de respostas aos cenários de emergências, de
                acordo com os riscos, as características e as circunstâncias das atividades, integrando-o ao PGR.
            </div>
            <div className='paragraph'>
                A NR em questão também determina a capacitação e treinamento em Segurança e Saúde no Trabalho em
                caráter inicial, periódico e eventual, com certificação disponibilizada ao trabalhador e uma copia mantida na
                organização, com permissão ao aproveitamento de conteúdos de treinamentos ministrados na mesma
                organização conforme critérios estabelecidos.
            </div>
            <div className='paragraph'>
                O PGR tem como objetivo geral a preservação da saúde e da integridade física dos trabalhadores, para fins de
                prevenção e gerenciamento dos riscos ocupacionais, através do desenvolvimento das etapas de elaboração do
                inventário e do plano de ação a partir dos riscos ambientais existentes nos locais de trabalho.
                Por solicitação da <span className='bold'>{empresaRazaoSocial}</span>, visando atender à legislação supracitada, realizamos estudos técnicos
                dos trabalhos a serem realizados pela empresa, cujas considerações apresentamos detalhadamente na
                sequência.
            </div>
            <div className='paragraph'>
                A avaliação e as recomendações oferecidas constituem-se num sistêmico parecer técnico e científico das
                condições levantadas, designando a adoção de eventuais medidas de correção propostas, sob inteira
                responsabilidade da empresa contratante.
                Ao concluirmos esse programa estamos convictos de que a sua aplicação criteriosa e adequada refletirá numa
                redução acentuada da ocorrência de fatores ambientais prejudiciais aos trabalhadores, propiciando melhoria
                nas condições de trabalho da organização.
            </div>
            <div className='tituloCap' data-new-page data-sum>2. OBJETIVOS ESPECÍFICOS DO PROGRAMA</div>
            <div className='paragraph'>Este programa abrange um estudo dos riscos ocupacionais aos quais os funcionários da <span className='bold'>{empresaRazaoSocial}</span>,
                estão expostos ao desenvolver suas atividades, com o objetivo de reconhecer cada risco e a propor
                medidas que visam atenuá-los ou até mesmo eliminá-los, em atendimento ao item 1.5 da Norma
                Regulamentadora 1 – NR 1, que apresenta para fins de prevenção o Gerenciamento dos Riscos Ocupacionais em
                questão.
            </div>
            <div className='tituloCap' data-new-page data-sum>3. IDENTIFICAÇÃO DA EMPRESA</div>
            <div className="table-div razao-social">
                <div className="table-tr">
                    <div className="table-td  colspan2">
                        <b>RAZÃO SOCIAL:</b><br />
                        {empresaRazaoSocial}
                    </div>
                    <div className="table-td"><b>CNPJ:</b><br />{empresaCNPJ}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan2"><b>ENDEREÇO: </b><br />{empresaEndereco}, {empresaEndNumero}</div>
                    <div className="table-td"><b>CEP:</b><br />{empresaCep}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>BAIRRO:</b><br />{empresaBairro}</div>
                    <div className="table-td"><b>CIDADE:</b><br />{empresaCidade}</div>
                    <div className="table-td"><b>UF:</b><br />{empresaEstado}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>TELEFONE:</b><br />{empresaTelefone}</div>
                    <div className="table-td"><b>TELEFONE CELULAR:</b><br />{empresaCelular}</div>
                    <div className="table-td"><b>E-MAIL:</b><br />{empresaEmail}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan3"><b>RAMO DE ATIVIDADE:</b><br />{atividadeCipa}</div>
                    <div className="table-td"></div>
                    <div className="table-td"></div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>CNAE:</b><br />{empresaCnae}</div>
                    <div className="table-td"><b>GRAU DE RISCO (NR 4): {fdtGrauRisco}</b></div>
                    <div className="table-td"><b>INSCRIÇÃO ESTADUAL:</b><br />{empresaInscEstadual}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan3"><b>TOTAL DE TRABALHADORES:</b><br />{funcionariosTotal}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>RESPONSÁVEL PELA EMPRESA:</b></div>
                    <div className="table-td"><b>NOME:</b> {empresaRespNome}</div>
                    <div className="table-td"><b>CARGO:</b> {empresaRespCargo}</div>
                </div>
                <div className="table-tr" style={{ borderWidth: '1px', color: '#000' }}>
                    <div className="table-td colspan2" ><b>TELEFONE:</b> {empresaRespTelefone}</div>
                    <div className="table-td"><b>E-MAIL:</b> {empresaRespEmail}</div>
                </div>
            </div>
            <div className='paragraph'>
                Código da Atividade (conforme cartão CNPJ).<br />
                <b>{empresaCnae} - {atividadeCipa}</b><br />
                Em conformidade com a NR-4 do MTE, QUADRO I, com redação dada pela Portaria nº. 76, de 21/11/2008, a
                empresa caracteriza-se com <span className='bold'>grau de risco {fdtGrauRisco}.</span>
            </div>

            <div className='tituloCap' data-sum>3.1. HORÁRIO DE TRABALHO</div>
            <div>Conforme Regime CLT.</div>
            <div className='tituloCap' data-sum>3.2. QUADRO RESUMO DE FUNÇÕES/SETORES/NÚMERO DE FUNCIONÁRIOS AFETADOS</div>
            <div className='table-div quadro-resumo'>

                <div className='table-tr'>
                    <div className='table-td th'>GHE</div>
                    <div className='table-td th'>FUNÇÃO</div>
                    <div className='table-td th'>Nº DE FUNCIONÁRIOS</div>
                    <div className='table-td th'>ATIVIDADES</div>
                </div>

                {funcoes.map((item: any) => (
                    <div className='table-tr' key={item.id}>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.pgrGhe?.nome ?? 'N/A'}</div>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.AteBaseFuncao?.nome ?? 'N/A'}</div>
                        <div className='table-td' style={{ textAlign: 'center' }}>
                            {item.num_tra_masc + item.num_tra_fem}
                        </div>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.descricao}</div>
                    </div>
                ))}

                <div style={{ fontWeight: 700 }}>Total de funcionários atual: {funcionariosTotal}.</div>

            </div>
            <div className='tituloCap' data-sum>3.3. CONSTITUIÇÃO DA CIPA</div>
            <div className='paragraph'>
                Os empregados terão participação efetiva neste programa, através dos seus representantes da CIPA que
                estiverem em gestão, dando sugestões e informando a administração sobre condições que julgarem de risco.
                O documento base, suas alterações e complementações deverão ser apresentados e discutidos na CIPA, quando
                existente na empresa, de acordo com a NR-10 do MTE, sendo uma cópia anexada ao livro de ata dessa comissão.
                A NR-5 do MTE estabelece:
            </div>
            <div className='paragraph'>
                DA CONSTITUIÇÃO
            </div>
            <div className='paragraph'>
                5.2. Devem constituir CIPA, por estabelecimento, e mantê-la em regular funcionamento as empresas privadas,
                públicas, sociedades de economia mista, órgãos da administração direta e indireta, instituições beneficentes,
                associações recreativas, cooperativas, bem como outras instituições que admitam trabalhadores como
                empregados.
            </div>
            <div className='paragraph'>
                5.4. A empresa que possuir em um mesmo município dois ou mais estabelecimentos deverá garantir a
                integração das CIPA e dos designados, conforme o caso, com o objetivo de harmonizar as políticas de segurança
                e saúde no trabalho.
            </div>
            <div className='paragraph'>
                DAS CONTRATANTES E CONTRATADAS
            </div>
            <div className='paragraph'>
                5.46. Quando se tratar de empreiteiras ou empresas prestadoras de serviços considera-se estabelecimento,
                para fins de aplicação desta NR, o local em que seus empregados estiverem exercendo suas atividades.
            </div>
            <div className='paragraph'>
                5.47. Sempre que duas ou mais empresas atuarem em um mesmo estabelecimento, a CIPA ou designado da
                empresa contratante deverá, em conjunto com as das contratadas ou com os designados, definir mecanismos
                de integração e de participação de todos os trabalhadores em relação às decisões das CIPA existentes no
                estabelecimento.
            </div>
            <div className='paragraph'>
                5.48. A contratante e as contratadas, que atuem num mesmo estabelecimento, deverão implementar, de forma
                integrada, medidas de prevenção de acidentes e doenças do trabalho, decorrentes da presente NR, de forma a
                garantir o mesmo nível de proteção em matéria de segurança e saúde a todos os trabalhadores do
                estabelecimento.
            </div>
            <div className='paragraph'>
                5.49. A empresa contratante adotará medidas necessárias para que as empresas contratadas, suas CIPA (S), os
                designados e os demais trabalhadores lotados naquele estabelecimento recebam as informações sobre os riscos
                presentes nos ambientes de trabalho, bem como sobre as medidas de proteção adequadas.
            </div>
            <div className='paragraph'>
                5.50. A empresa contratante adotará as providências necessárias para acompanhar o cumprimento pelas
                empresas contratadas que atuam no seu estabelecimento, das medidas de segurança e saúde no trabalho.
            </div>
            <div className='paragraph'>
                <b>
                    De acordo com o código de atividade 7112-0/00 - SERVIÇOS DE ENGENHARIA, a empresa pertence ao grupo
                    C-35 do Quadro I da NR-5 do MTE, e deverá constituir CIPA a partir de 51 funcionários. Portanto, com o
                    número atual de funcionários a empresa está obrigada a constituir CIPA. Porém quando a empresa não se
                    enquadrar no quadro I da NR-5 do MTE, a mesma designará um responsável pelo cumprimento dos objetivos
                    desta NR.
                </b>
            </div>
            <div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', fontSize: '14px', fontWeight: 'bolder' }}>
                        <b>QUADRO I - NR-5 - DIMENSIONAMENTO DE CIPA</b>
                    </div>
                    <table className="cipa-tabela-content">
                        <thead>
                            <tr>
                                <th className='cipa-tabela-header-content' rowSpan={2}>
                                    Grau de Risco*
                                </th>
                                <th className='cipa-tabela-header-content' rowSpan={2}>
                                    Nº de INTEGRANTES da CIPA
                                </th>
                                <th className='cipa-tabela-header-content' colSpan={14}>
                                    Número de Empregados
                                </th>
                            </tr>
                            <tr>
                                <th className='cipa-tabela-header-content'>0 a 19</th>
                                <th className='cipa-tabela-header-content'>20 a 29</th>
                                <th className='cipa-tabela-header-content'>30 a 50</th>
                                <th className='cipa-tabela-header-content'>51 a 80</th>
                                <th className='cipa-tabela-header-content'>81 a 100</th>
                                <th className='cipa-tabela-header-content'>101 a 120</th>
                                <th className='cipa-tabela-header-content'>121 a 140</th>
                                <th className='cipa-tabela-header-content'>141 a 300</th>
                                <th className='cipa-tabela-header-content'>301 a 500</th>
                                <th className='cipa-tabela-header-content'>501 a 1.000</th>
                                <th className='cipa-tabela-header-content'>1.001 a 2.500</th>
                                <th className='cipa-tabela-header-content'>2.501 a 5.000</th>
                                <th className='cipa-tabela-header-content'>5.001 a 10.000</th>
                                <th className='cipa-tabela-header-content'>
                                    Acima de 10.000 para cada grupo de 2.500 acrescentar
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='cipa-tabela-linha-content' rowSpan={2}>1</td>
                                <td className='cipa-tabela-linha-content'>Efetivos</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content'>Suplentes</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content' rowSpan={2}>2</td>
                                <td className='cipa-tabela-linha-content'>Efetivos</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>10</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content'>Suplentes</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content' rowSpan={2}>3</td>
                                <td className='cipa-tabela-linha-content'>Efetivos</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>10</td>
                                <td className='cipa-tabela-linha-content'>12</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content'>Suplentes</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content' rowSpan={2}>4</td>
                                <td className='cipa-tabela-linha-content'>Efetivos</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>6</td>
                                <td className='cipa-tabela-linha-content'>9</td>
                                <td className='cipa-tabela-linha-content'>11</td>
                                <td className='cipa-tabela-linha-content'>13</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                            </tr>
                            <tr>
                                <td className='cipa-tabela-linha-content'>Suplentes</td>
                                <td className='cipa-tabela-linha-content'>-</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>1</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                                <td className='cipa-tabela-linha-content'>3</td>
                                <td className='cipa-tabela-linha-content'>4</td>
                                <td className='cipa-tabela-linha-content'>5</td>
                                <td className='cipa-tabela-linha-content'>7</td>
                                <td className='cipa-tabela-linha-content'>8</td>
                                <td className='cipa-tabela-linha-content'>10</td>
                                <td className='cipa-tabela-linha-content'>2</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='paragraph'>
                *Grau de Risco conforme estabelecido no Quadro I da NR-04 - Relação da Classificação Nacional de Atividades Econômicas - CNAE (Versão 2.0), com correspondente Grau de Risco - GR para fins de dimensionamento do SESMT.
            </div>
            <div className='tituloCap' data-sum>3.4. CONSTITUIÇÃO DO SESMT</div>
            <div className='paragraph'>
                As empresas deverão manter, obrigatoriamente, Serviços Especializados em Engenharia de Segurança e em
                Medicina do Trabalho - SESMT, com a finalidade de promover a saúde e proteger a integridade do trabalhador
                no local de trabalho. A NR-4 do MTE estabelece que:
            </div>
            <div className='paragraph'>
                4.1. As empresas privadas e públicas, os órgãos públicos da administração direta e indireta e dos poderes
                Legislativo e Judiciário, que possuam empregados regidos pela Consolidação das Leis do Trabalho - CLT,
                manterão, obrigatoriamente, Serviços Especializados em Engenharia de Segurança e em Medicina do Trabalho,
                com a finalidade de promover a saúde e proteger a integridade do trabalhador no local de trabalho. (104.001-4
                / I2)
            </div>
            <div className='paragraph'>
                4.2. O dimensionamento dos Serviços Especializados em Engenharia de Segurança e em Medicina do Trabalho
                vincula-se à gradação do risco da atividade principal e ao número total de empregados do estabelecimento,
                constantes dos Quadros I e II, anexos, observadas as exceções previstas nesta NR. (104.002-2 / I1)
            </div>
            <div className='paragraph'>
                4.20. Quando se tratar de empreiteiras ou empresas prestadoras de serviços, considera-se estabelecimento,
                para fins de aplicação desta NR, o local em que os seus empregados estiverem exercendo suas atividades.
            </div>

            <div className='table-div sesmt'>
                <div style={{ display: 'flex', justifyContent: 'center', fontSize: '1rem', margin: '10px 0' }}><b>QUADRO I - NR-4 - DIMENSIONAMENTO DO SESMT</b></div>
                <div className='table-tr' style={{ borderTop: '1px solid' }}>
                    <div className='table-td th'>Grau de Risco</div>
                    <div className='table-td th'>
                        <div className='horizontal-td'>
                            Nº de Empregados no Estabelecimento
                        </div>
                        <div>
                            Nº de Membros da CIPA
                        </div>
                    </div>
                    <div className='table-td th'>50 a 100</div>
                    <div className='table-td th'>101 a 250</div>
                    <div className='table-td th'>251 a 500</div>
                    <div className='table-td th'>501 a 1000</div>
                    <div className='table-td th'>1001 a 2000</div>
                    <div className='table-td th'>2001 a 3500</div>
                    <div className='table-td th'>3501 a 5000</div>

                    <div className='table-td th'>Acima de 5.000 para cada grupo de 4.000 ou fração acima de 2.000**</div>
                </div>
                {/*/////////////////////////////////////////*/}
                {fdtGrauRisco == 4 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>4</div>
                            <div className='table-td'>5</div>
                            <div className='table-td'>8</div>
                            <div className='table-td'>10</div>
                            <div className='table-td'>3</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*//////////////////////////////////////////////////////////////*/}
                {fdtGrauRisco == 3 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>4</div>
                            <div className='table-td'>6</div>
                            <div className='table-td'>8</div>
                            <div className='table-td'>3</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                {fdtGrauRisco == 2 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>5</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                {fdtGrauRisco == 1 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                    </>
                )}

                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                <div style={{ marginTop: '10px' }}>(*) Tempo parcial (mínimo de três horas)</div>
                <div style={{ marginTop: '10px' }}>(**) O dimensionamento total deverá ser feito levando-se em consideração o dimensionamento da faixa de
                    3.501 a 5.000, acrescido do dimensionamento do(s) grupo(s) de 4.000 ou fração acima de 2.000.</div>
                <div style={{ marginTop: '10px' }}>(***) O empregador pode optar pela contratação de um enfermeiro do trabalho em tempo parcial, em
                    substituição ao auxiliar ou técnico de enfermagem do trabalho.</div>
                <div style={{ marginTop: '10px' }}>OBSERVAÇÕES:</div>
                <div style={{ marginTop: '10px' }}>A) hospitais, ambulatórios, maternidades, casas de saúde e repouso, clínicas e estabelecimentos similares
                    deverão contratar um enfermeiro do trabalho em tempo integral quando possuírem mais de quinhentos
                    trabalhadores; e</div>
                <div style={{ marginTop: '10px' }}>
                    B) em virtude das características das atribuições do SESMT, não se faz necessária a supervisão do técnico de
                    enfermagem do trabalho por enfermeiro do trabalho, salvo quando a atividade for executada em hospitais,
                    ambulatórios, maternidades, casas de saúde e repouso, clínicas e estabelecimentos similares.
                </div>
                <div className='paragraph' style={{ fontSize: '1rem', marginTop: '10px' }}>
                    <b>
                        {funcionariosTotal < 50 ? (
                            <>
                                Portanto, a empresa objeto deste PGR fica desobrigada a constituir SESMT de acordo com o Quadro acima
                                considerando o número de funcionários atual e o grau de risco que é {fdtGrauRisco}.
                            </>
                        ) : (
                            <>
                                Portanto, a empresa objeto deste PGR é obrigada a constituir SESMT de acordo com o Quadro acima
                                considerando o número de funcionários atual e o grau de risco que é {fdtGrauRisco}.
                            </>
                        )}

                    </b>
                </div>
            </div>

            <div className='tituloCap' data-new-page data-sum>4. METODOLOGIA PARA LEVANTAMENTO PRELIMINAR DE PERIGO (1.5.4.2)</div>

            <div className='tituloCap' data-sum>4.1. METODOLOGIA PARA IDENTIFICAÇÃO DOS PERIGOS (1.5.4.3)</div>
            <div className='paragraph'>
                Foram realizadas entrevistas com os responsáveis setoriais e ainda com os trabalhadores, atentando para a
                sistemática e o desempenho laboral, para a identificação dos riscos existentes, a frequência e forma de
                exposição, bem como a localização das fontes geradoras. Posteriormente, foram efetuadas avaliações
                qualitativas e quantitativas dos agentes ambientais mais significativos e verificadas as condições de segurança
                e higiene do trabalho das instalações. Com base nos levantamentos anteriormente citados elabora-se o
                Programa de Gerenciamento de Riscos.
            </div>
            <div className='paragraph'>
                NOTA IMPORTANTE: O conteúdo do presente levantamento técnico não tem a pretensão de esgotar o assunto,
                principalmente os relacionados com doenças ocupacionais e com acidentes graves e iminentes. Todavia, como
                informações podem ter sido omitidas, mesmo que involuntariamente, durante a fase de reconhecimento
                (entrevistas com trabalhadores, lideranças e visitas in loco), é de se supor alguma eventual omissão de risco
                e/ou respectiva medida de controle. Havendo a detecção de algum risco potencial que não tenha sido informado
                e observado, solicitamos contato imediato com o responsável técnico por esse PGR, para que o programa possa
                ser complementado.
            </div>
            <div className='tituloCap' data-sum>4.2. METODOLOGIA PARA AVALIAÇÃO DE RISCOS. CONSIDERA COMO CRITÉRIO A SEVERIDADE E A GRAVIDADE PARA DETERMINAÇÃO DO NÍVEL DO RISCO (1.5.4.4)</div>
            <div className='paragraph'>Conforme especificado no item 11 que trata da Estrutura do PGR.</div>
            <div className='tituloCap' data-sum>4.2.1. A GRADAÇÃO DA SEVERIDADE CONSIDERA A MAGNITUDE DA CONSEQUÊNCIA E O NÚMERO DE TRABALHADORES AFETADOS (1.5.4.4.3)</div>
            <div className='paragraph'>Conforme especificado no Item 11 que trata da Estrutura do PGR, e item 3.3., relacionando o número de funcionários afetados.</div>
            <div className='tituloCap' data-sum>4.2.1.1. A GRADAÇÃO DA PROBABILIDADE CONSIDERA REQUISITOS ESTABELECIDOS EM NORMA.
                AS MEDIDAS DE PREVENÇÃO IMPLEMENTADAS. AS EXIGÊNCIAS DA ATIVIDADE DE TRABALHO.
                TOMA COMO REFERÊNCIA VALORES ESTABELECIDOS NA NR 09 E NR15 (1.5.4.4.4)</div>
            <div className='paragraph'>Conforme Item 11 e 13 desse documento.</div>
            <div className='tituloCap' data-sum>4.2.1.2. PERIODICIDADE MÍNIMA PARA REVISÃO E EM QUAIS SITUAÇÕES OCORRERÃO REVISÕES ANTECIPADAS (1.5.4.4.6)</div>
            <div className='paragraph'>A Periodicidade de Revisão deste documento é de 12 meses. As Revisões antecipadas se darão conforme análise técnica da situação apresentada.</div>
            <div className='tituloCap' data-sum>4.2.1.3. CONSULTA AOS TRABALHADORES QUANTO A PERCEPÇÃO DE RISCO (1.5.3.3)</div>
            <div className='paragraph'>Os trabalhadores são consultados e orientados a informar quaisquer situações que possam gerar riscos á saúde e segurança.</div>
            <div className='tituloCap' data-sum>4.2.1.4. DIVULGAÇÃO AOS TRABALHADORES DOS RISCOS PRESENTES NO INVENTÁRIO DE RISCOS (1.5.3.3)</div>
            <div className='paragraph'>Os trabalhadores são informados através das ordens de serviço, reuniões da CIPA e DDS.</div>
            <div className='tituloCap' data-new-page data-sum>5. RESPONSABILIDADES E COMPETÊNCIAS (1.5.3)</div>
            <div className='paragraph'>Conforme NR 1.5.3, das responsabilidades:</div>
            <li style={{ marginLeft: '20px' }}>A organização deve implementar, por estabelecimento, o gerenciamento de riscos ocupacionais em suas atividades.</li>
            <li style={{ marginLeft: '20px' }}>O gerenciamento de riscos ocupacionais deve constituir um Programa de Gerenciamento de Riscos - PGR.</li>
            <div className='paragraph'>
                De acordo com a NR 1.5.7.2, os documentos integrantes do PGR devem ser elaborados sob a responsabilidade
                da organização, respeitado o disposto nas demais Normas Regulamentadoras, datados e assinados.
            </div>
            <div className='paragraph'>Cabe ao empregador:</div>
            <li style={{ marginLeft: '20px' }}>Estabelecer, programar e assegurar o cumprimento do PGR como atividade permanente na Empresa.</li>
            <div className='paragraph'>Cabe às Supervisões e demais Gestões Imediatas:</div>
            <li style={{ marginLeft: '20px' }}>Identificar os Riscos Potenciais de sua área de responsabilidade e introduzir medidas de proteção para sua redução ou eliminação.</li>
            <li style={{ marginLeft: '20px' }}>Tomar todas as providências para a implantação efetiva das medidas necessárias para o controle dos riscos ambientais.</li>
            <li style={{ marginLeft: '20px' }}>Viabilizar recursos para a realização de modificações destinadas à melhoria das condições de trabalho.</li>
            <li style={{ marginLeft: '20px' }}>Ser exemplo no cumprimento das Normas de Segurança e Saúde, exigindo o mesmo de seus liderados.</li>
            <li style={{ marginLeft: '20px' }}>Antes de designar a execução de qualquer serviço, tarefa ou atividade, de forma prévia: avaliar, eliminar ou minimizar os riscos ambientais existentes.</li>
            <div>Cabe aos empregados:</div>
            <li style={{ marginLeft: '20px' }}>Colaborar e participar da implantação e execução do PGR, como multiplicadores de melhoria, com a permanente vigilância das condições de segurança e saúde nos ambientes de trabalho.</li>
            <li style={{ marginLeft: '20px' }}>Cumprir as Normas de Segurança e Saúde Ocupacional, visando seu bem estar físico e mental.</li>
            <li style={{ marginLeft: '20px' }}>Comunicar à gestão imediata todas as ocorrências de condições de insegurança encontradas, que  possam implicar em Riscos à Saúde.</li>
            <li style={{ marginLeft: '20px' }}>Usar sempre os equipamentos de proteção individual e coletiva fornecidos e/ou instalados pela Empresa.</li>
            <div className='tituloCap' data-new-page data-sum>6. ANÁLISE E INVESTIGAÇÃO DE ACIDENTES, INCIDENTES E DOENÇAS DO TRABALHO (1.5.5.5)</div>
            <div>
                Deverão ser apresentadas, adicionalmente, nas Reuniões de Resultados ou dos Comitês de SSMA análises e
                informações estatísticas sobre acidentes e incidentes e doenças do trabalho, as reincidências, os tipos de lesões
                mais frequentes, as partes do corpo mais atingidas, entre outras. Deverá ser mantido por cada unidade arquivos
                com todas as informações necessárias para a elaboração do Mapa Estatístico e dos Anexos, dentro dos modelos
                legais, para fins de fiscalização do SRT – Secretaria Regional do Trabalho, órgão do MTE.
            </div>
            <div className='tituloCap' data-sum>6.1. TIPOS DE EVENTOS </div>
            <div>
                <div><b>INCIDENTE: </b>Desvio Comportamental; Quase Acidente; Acidente Material, Acidente Ambiental; Incêndio.</div>
                <div><b>SAME: </b>Simples Atendimento Médico.</div>
                <div><b>ACIDENTE TÍPICO: </b>Pode ser Com ou Sem Afastamento.</div>
                <div>
                    <b>ACIDENTE EM TRÂNSITO: </b>Pode ser Com ou Sem Afastamento.
                </div>
                <div><b>ACIDENTE DE TRAJETO: </b>Pode ser Com ou Sem Afastamento. Cada um dos eventos acima pode ainda ser com ALTO, MÉDIO ou BAIXO POTENCIAL DE PERDA.</div>
            </div>
            <div className='tituloCap' data-sum>6.2. REGISTRO E CLASSIFICAÇÃO DO EVENTO </div>
            <div className='paragraph'>
                Todo empregado ao identificar qualquer evento relacionado à Segurança do Trabalho, Saúde Ocupacional e
                Meio Ambiente deve comunicar imediatamente ao seu superior imediato ou fazer o registro num formulário
                disponível. No caso de lesão corporal, o empregado deve ser encaminhado ou orientado a procurar de imediato
                o ambulatório médico da unidade, se não houver, deve ser encaminhado imediatamente para uma unidade de
                saúde.
            </div>
            <div className='paragraph'>
                A prestação dos primeiros socorros e a busca pelo menor impacto possível a saúde das pessoas deve ser sempre
                prioritária em todo processo. O Serviço Médico deve realizar o primeiro atendimento, fazer o registro
                “SSMA.FP004 - Investigação e Análise de Acidentes e Incidentes; Avaliação de Pertinência; Descaracterização de
                Acidente do Trabalho” e comunicar de imediato ao gestor do empregado, que deve acionar o Engenheiro ou
                Técnico de Segurança para verificarem os fatos e estabelecer ou não o nexo causal. Caso não seja estabelecido
                o nexo causal, ou seja, verificado que não se trata de um acidente do trabalho, deve ser preenchido o
                “SSMA.FP004 - Investigação e Análise de Acidentes e Incidentes; Avaliação de Pertinência; Descaracterização de
                Acidente do Trabalho” o formulário de Descaracterização de Acidente do Trabalho, exclusivamente pelo Técnico
                ou Engenheiro de Segurança. Se houver lesão corporal, cabe ao Médico do Trabalho avaliar a gravidade desta
                lesão e fazer a classificação em Lesão Com Afastamento ou Lesão Sem Afastamento. Quando necessário, o
                Médico do Trabalho ou profissional da área de saúde devem encaminhar a pessoa para atendimento externo
                especializado ou mesmo atendimento emergencial.
            </div>
            <div className='paragraph'>
                Nas unidades que não houver Serviço de Saúde interno, ou se no momento não estejam presentes, o empregado
                deve ser encaminhado de imediato e tratado numa unidade de saúde externa adequada.
            </div>
            <div className='paragraph'>
                - Se o empregado tem condições de retornar para a sua função, podendo decidir por seu afastamento ou por
                um trabalho restrito, mesmo que o médico externo não tenha recomendado nenhum afastamento; ou
            </div>
            <div className='paragraph'>
                - Se o empregado tem de fato necessidade de afastamento do trabalho, podendo decidir por mudar o período
                de afastamento ou mesmo não afastar o empregado, conforme atribuições que lhe são conferidas pelo
                Conselho de Medicina, no exercício legal de sua profissão, mesmo que o médico externo tenha emitido um
                atestado. No caso de trabalho restrito ou mudança de função, a avaliação para determinar a outra atividade
                deve ser feita em conjunto pelos seguintes profissionais: Médico/Enfermeiro do Trabalho, Técnico/Engenheiro
                de Segurança e Supervisor/Gestor do Setor que irá receber a pessoa. No caso de incidentes, dependendo do
                tipo de incidente, a unidade pode usar o “SSMA.FP004 - Investigação e Análise de Acidentes e Incidentes;
                Avaliação de Pertinência; Descaracterização de Acidente do Trabalho”, o Cartão de Registro de Incidentes, o
                Cartão de Observação Comportamental ou mesmo um outro tipo de registro, inclusive eletrônico, que tenha
                disponível na unidade para registro do evento.
            </div>
            <div className='tituloCap' data-sum>6.3. COMUNICAÇÃO </div>
            <div className='paragraph'>
                Todo e qualquer acidente e incidente deve ser comunicado imediatamente ao superior imediato do empregado
                ou responsável pelo local onde ocorreu o evento. Este por sua vez, deve garantir a comunicação para o gestor
                responsável pelo local onde ocorreu o evento, que por sua vez deve convocar a Comissão de Investigação
                compostas por diversos tipos de profissionais, conforme definido no item de INVESTIGAÇÃO e a necessidade
                para cada tipo de evento. A comunicação interna para os demais níveis dentro da unidade fica a critério do
                gestor do local, onde ocorreu o evento, e equipe de SSMA, que podem utilizar o DDS – Diálogos Diretos de
                Segurança ou outros meios para divulgar para todos sobre o ocorrido. No caso de ACA e evento com APP a
                comunicação é obrigatória para os empregados da mesma função ou riscos similares.
            </div>

            <div className='tituloCap' data-sum>6.4. ACIDENTE COM AFASTAMENTO (ACA) E EVENTO COM ALTO POTENCIAL DE PERDA (APP) </div>
            <div className='paragraph'>
                O Gestor do local onde ocorreu o evento, ou quem o substituir, deve comunicar ao Gerente da Unidade. Este
                por sua vez deve comunicar de imediato por fone, SMS, WhatsApp ou outro meio eletrônico para o Diretor
                responsável (no caso das Fábricas é o Diretor Industrial). Já o Gerente de SSMA, ou quem o substituir, deve
                comunicar ao Gerente Corporativo de SSMA. Num prazo máximo de 48h, o Gerente de SSMA, ou quem o
                substituir, deve enviar um e-mail para o Diretor responsável e sua Alta Gerência, além do Gerente Corporativo
                de SSMA, com a Comunicação de Acidentes e Incidentes, conforme modelo padrão do anexo 03. Nas unidades
                menores, que não tenham profissionais de SSMA, deve ser feito por um representante da CIPA ou de RH.
            </div>
            <div><b>EVENTO COM MÉDIO POTENCIAL DE PERDA (MPP)</b></div>
            <div className='paragraph'>
                O gestor do local onde ocorreu o evento, ou quem o substituir, deve comunicar para o Gerente da Unidade. O
                Gerente de SSMA, ou quem o substituir, deve comunicar para o Gerente Corporativo de SSMA
            </div>
            <div><b>EVENTO COM BAIXO POTENCIAL DE PERDA (BPP)</b></div>
            <div className='paragraph'>
                A comunicação deve ir até o gestor do local. O evento deve ser registrado e acompanhado para todas as ações serem devidas tratadas e resolvidas.
            </div>
            <div className='tituloCap' data-sum>6.5. INVESTIGAÇÃO DE ACIDENTE E INCIDENTE </div>
            <div className='paragraph'>
                “A causa que leva a um incidente, pode ser a mesma que poderia levar a um acidente com morte”. O local onde
                ocorreu o evento e agente da lesão devem ser preservados até a realização de uma investigação mais detalhada.
                Se for o caso, a liberação para retomada da operação da máquina/equipamento deverá ser realizada pela equipe
                de SSMA.
            </div>
            <div className='paragraph'>
                O processo de investigação deve iniciar se atendo aos fatos relativos ao evento e ao potencial deste causar
                danos, sendo assim, um evento de alto potencial de perda, mesmo que não tenha tido lesão corporal, deve ser
                investigado com a mesma profundidade como se houvesse fosse um acidente grave com afastamento, para
                encontrarmos as causas raízes e evitarmos que o evento se repita. A investigação dos acidentes deve ser
                realizada e divulgada em até 15 dias úteis após o evento. Salvo em processos que dependam de perícias técnicas
                e resultados de laboratório, nestes casos, o gerente da unidade deve informar e justificar um prazo maior.
            </div>
            <div className='paragraph'>
                O gestor do local onde ocorreu o evento é o responsável por conduzir o processo de investigação do acidente,
                com o apoio do setor de SSMA da unidade. O gestor deve convocar uma Comissão de Investigação, que deve
                ser formada conforme o tipo de evento. O registro da investigação deve ser feito no formulário padrão
                “SSMA.FP004 - Investigação e Análise de Acidentes e Incidentes; Avaliação de Pertinência; Descaracterização de
                Acidente do Trabalho”. Caso haja mais de um acidentado, num mesmo evento, deve-se abrir uma ficha de
                investigação para cada pessoa que sofreu acidente, mesmo até que o processo de investigação siga junto. Sendo
                assim, somente neste caso, o número de eventos será o número de pessoas que sofreram lesões. Se houver
                várias pessoas envolvidas, mas só uma com lesão, neste caso, deve-se considerar apenas um evento.
            </div>
            <div className='tituloCap' data-sum>6.6. ACIDENTE COM AFASTAMENTO (ACA) E EVENTO COM ALTO POTENCIAL DE PERDA (APP)</div>
            <div className='paragraph'>
                A determinação da causa raiz deverá ser realizada utilizando a metodologia de Árvore de Causas. Na construção
                da árvore de causas é recomendado que seja feito uma reunião com a Comissão de Investigação, começando
                com a descrição do ocorrido, seguido de um BRAINSTORMING com os fatos relativos ao evento. Recomendamos
                ainda o uso do DIAGRAMA DE ISHIKAWA para ajudar na organização de causas que contribuíram para o efeito.
            </div>
            <div className='paragraph'>
                Para que finalmente se construa a árvore de causas. Importante frisar que para cada uma das causas raízes
                identificadas deve haver uma ação específica.
            </div>
            <div className='paragraph'>
                A Comissão de Investigação deve ser composta por:
            </div>
            <div>- Responsável pelo Local do Evento:</div>
            <div>- Gerente ou Coordenador (condutor do processo);</div>
            <div>- SSMA: Gerente ou Engenheiro (apoio técnico);</div>
            <div>- Gerente da Unidade;</div>
            <div>
                - Acidentado, testemunhas ou empregado de mesma função, quando houver e necessário (definido pelo condutor do processo);
            </div>
            <div>- Presidente, Vice ou Integrante da CIPA: obrigatório só no caso de ACA;</div>
            <div>
                - Outros profissionais, conforme a necessidade e situação (definido pelo condutor do processo): Manutenção,
                Serviço Saúde, Engenharia Industrial, etc.
            </div>
            <div className='tituloCap' data-sum>6.7. EVENTO COM MÉDIO POTENCIAL DE PERDA (MPP) </div>
            <div className='paragraph'>
                É obrigatório o uso da técnica de investigação dos 5 PORQUÊS. É recomendado o DIAGRAMA DE ISHIKAWA para
                auxiliar o processo de investigação, principalmente na determinação das causas. É opcional o uso da ÁRVORE
                DE CAUSAS.
            </div>
            <div>A Comissão de Investigação deve ser composta por:</div>
            <div>- Responsável pelo Local do Evento:</div>
            <div>- Supervisor (condutor do processo);</div>
            <div>- SSMA: Engenheiro ou Técnico (apoio técnico).</div>
            <div>- Acidentado, testemunhas ou empregado de mesma função, quando houver e necessário (definido pelo condutor do processo);</div>
            <div>
                - Presidente, Vice ou Integrante da CIPA: obrigatório só no caso de ASA; Outros profissionais, conforme a
                necessidade e situação (definido pelo condutor do processo): Manutenção, Serviço Saúde, Engenharia
                Industrial, etc.
            </div>
            <div className='tituloCap' data-sum>6.8. EVENTO COM BAIXO POTENCIAL DE PERDA (BPP) </div>
            <div>
                Não há obrigatoriedade de uso de nenhuma técnica de investigação, mas conforme o caso, o condutor do
                processo pode utilizar o 5 PORQUÊS, DIAGRAMA DE ISHIKAWA, ÁRVORE DE CAUSAS ou outro método, conforme
                o caso. Não há obrigatoriedade de formação da Comissão de Investigação, mas o responsável pelo processo
                deve ser sempre o responsável pelo local onde ocorreu o evento.
            </div>
            <div className='tituloCap' data-sum>6.9. REUNIÃO DE APRESENTAÇÃO DA INVESTIGAÇÃO</div>
            <div>
                Quando se tratar de ACA e evento com APP, num prazo de até 15 dias úteis após o evento o responsável pela
                unidade deve convocar uma reunião com o Diretor e Alta Gerência da área onde ocorreu o evento, além do
                Gerente Corporativo de SSMA, para apresentar as conclusões do processo de Investigação, bem como, suas
                causas, ações realizadas e previstas, quando for o caso. No caso de acidentes com lesão de maior gravidade o
                Presidente da CIPA deve convocar uma reunião extraordinária da CIPA.
            </div>
            <div className='tituloCap' data-sum>6.10. ACIDENTE DE TRAJETO </div>
            <div>
                O acidentado deve comunicar o ocorrido o mais rápido possível ao RH ou SSMA da unidade que trabalha,
                apresentando, assim que possível, o Boletim de Ocorrência (Polícia, Hospital, Bombeiro, SAMU). Só será
                caracterizado o acidente de trajeto que possuir Boletim de Ocorrência, comprovando que o local do evento está
                no percurso habitual e no horário compatível com o tempo necessário de ida ou volta do trabalho à residência.
                Não é obrigatório o mesmo procedimento e prazos de comunicação internos, no entanto, o evento deve ser
                investigado pelo SESMT. Como também, neste caso, não é obrigatória a árvore de causas, mesmo nos casos de
                afastamento ou de alto potencial de perda.
            </div>
            <div className='tituloCap' data-sum>6.11. DOENÇAS DO TRABALHO</div>
            <div>
                Doença ocupacional é um termo genérico que designa qualquer patologia relacionada à atividade
                desempenhada ou às condições encontradas no ambiente de trabalho
            </div>
            <div>
                Todo colaborador está exposto a riscos, de acordo com a atividade profissional exercida. A área de medicina
                ocupacional, portanto, atua com o objetivo de prever e mapear esses riscos, acompanhando trabalhadores e
                indicando procedimentos e condutas que visam evitar essas doenças.
            </div>
            <div>As doenças ocupacionais mais comuns são:</div>
            <div>LER (lesão por esforço repetitivo);</div>
            <div>Surdez temporária ou definitiva;</div>
            <div>Estresse ocupacional;</div>
            <div>DORT (distúrbios osteomoleculares relacionados ao trabalho);</div>
            <div>Dermatose ocupacional;</div>
            <div>Asma ocupacional</div>
            <div>
                A investigação dessas doenças ocorre através de exames que são definidos pelo PCMSO, especificamente, para
                a profissão de cada colaborador. Cabe à clínica de medicina do trabalho seguir à risca as orientações do
                documento, acompanhando a saúde do trabalhador por meio dos exames indicados. A investigação pode
                ocorrer também através de documentos de Segurança do Trabalho como: PPR – Programa de Proteção
                Respiratória, PPPA - Programa de Prevenção de Perdas Auditivas e AET – Analise Ergonômica do Trabalho.
            </div>
            <div className='tituloCap' data-new-page data-sum>7. PREPARAÇÃO PARA EMERGÊNCIAS (1.5.6)</div>
            <div className='tituloCap' data-sum>7.1. PROCEDIMENTOS EM CASO DE EMERGÊNCIA</div>
            <div>
                1. Em casos de emergências deve ser acionado primeiramente as equipes internas de atendimento a
                emergências (brigada de incêndio, CIPA);
            </div>
            <div>
                2. Ao a equipe chegar no local a mesma irá avaliar o local onde segregará e avaliará a gravidade da ocorrência;
            </div>
            <div>
                1. Caso tiver vítimas graves, deve ser realizado primeiros socorros pela equipe para evitar mais danos à vítima,
                acionar o socorro médico sendo SIATE ou SAMU de acordo com o tipo de ocorrência, realizar acompanhamento
                do colaborador, assim como auxiliar/informar a família, realizar abertura de CAT e caso necessário a empresa
                deverá orientar/dar assistência ao colaborador no pedido de aposentadoria no INSS ou solicitar recursos de
                afastamento, conforme legislação atual;
            </div>
            <div>
                2. Quando o dano da vítima for leve, deverá ser aplicado os primeiros socorros no local, realizar
                acompanhamento médico do colaborador afim de investigar quaisquer danos, realizar abertura de CAT e seguir
                a orientação médica (atestado, etc.)
            </div>
            <div>
                3. Quando houver danos materiais a equipe de atendimento local ficará responsável pela mitigação de
                posteriores danos (isolamento/contenção de áreas), caso necessário deverá ser acionada equipe de limpeza,
                recuperação ambiental do local, posteriormente a equipe de manutenção será acionada para manutenção do
                equipamento que sofreu danos. <b>Quando houver exposição a produtos químicos, acionar equipe especializada
                    para atendimento;</b>
            </div>
            <div>
                3. Posteriormente à ocorrência deve ser devidamente investigada e tratada para evitar a reincidência de
                ocorrências de tal natureza.
            </div>
            <div className='tituloCap' data-new-page data-sum>8. ACOMPANHAMENTO DA SAÚDE OCUPACIONAL DOS TRABALHADORES</div>
            <div className='tituloCap'>
                8.1. DESENVOLVIMENTO DE AÇÕES EM SAÚDE OCUPACIONAL DOS TRABALHADORES INTEGRADAS
                ÀS DEMAIS MEDIDAS DE PREVENÇÃO EM SST, DE ACORDO COM OS RISCOS GERADOS PELO
                TRABALHO (1.5.5.4)
            </div>
            <div>São realizadas Ações estabelecidas no PCMSO.</div>
            <div className='tituloCap'>
                8.2. PROCESSO PREVENTIVO PLANEJADO, SISTEMÁTICO E CONTINUADO, DE ACORDO COM A
                CLASSIFICAÇÃO DE RISCOS OCUPACIONAIS E NOS TERMOS DA NR-07 (1.5.5.4)
            </div>
            <div>
                Para o controle da saúde dos empregados, é desenvolvido o Programa de Controle Médico de Saúde
                Ocupacional.
            </div>
            <div className='tituloCap' data-new-page data-sum>9. CAPACITAÇÃO E TREINAMENTO EM SEGURANÇA E SAÚDE NO TRABALHO (1.7)</div>
            <div className='tituloCap'>
                9.1. EXISTE PROCEDIMENTO ESTABELECIDO PARA CAPACITAÇÃO E TREINAMENTOS EM
                SEGURANÇA DE TRABALHO, EM CONFORMIDADE COM O DISPOSTO NAS NR’S
            </div>
            <div>
                Todos os trabalhadores devem receber treinamento: admissional, antes do início de sua atividade na empresa,
                periódico e eventual, conforme a legislação de segurança e saúde no trabalho. Todos os empregados devem
                receber treinamentos admissional e periódico, visando a garantir a execução de suas atividades com segurança.
                O treinamento admissional deve ser ministrado dentro do horário de trabalho, antes de o trabalhador iniciar
                suas atividades, constando de:
            </div>
            <div>
                a) Informações sobre as condições e meio ambiente de trabalho;
            </div>
            <div>
                b) Riscos inerentes a sua função;
            </div>
            <div>
                c) Uso adequado dos Equipamentos de Proteção Individual - EPI;
            </div>
            <div>
                d) Informações sobre os Equipamentos de Proteção Coletiva - EPC, existente na empresa ou no canteiro de
                obra;
            </div>
            <div>
                e) DST – Doenças Sexualmente Transmissíveis;
            </div>
            <div>
                f) Prevenção contra incêndios;
            </div>
            <div>
                h) Coleta seletiva.
            </div>
            <div style={{ marginTop: '25px' }}>O treinamento periódico deve ser ministrado:</div>
            <div>a) sempre que se tornar necessário;</div>
            <div>b) ao início de cada fase da obra.</div>
            <div style={{ marginTop: '25px' }}>O treinamento eventual será promovido sempre que ocorrer qualquer das seguintes situações:</div>
            <li>Mudança nos procedimentos, condições ou operações de trabalho;</li>
            <li>Evento que indique a necessidade de novo treinamento;</li>
            <li>
                Retorno de afastamento ao trabalho por período superior a 90 dias. A carga horária e o conteúdo programático
                do treinamento eventual devem atender à situação que o motivou.
            </li>
            <div>
                É importante que os treinamentos sejam realizados durante a jornada de trabalho, por profissional legalmente
                habilitado, dependendo do conteúdo programático ou por trabalhador qualificado, ambos em Segurança e
                Saúde no Trabalho. Ao término do treinamento, deve ser emitido certificado contendo o nome do trabalhador,
                conteúdo programático, carga horária, data, local de realização do treinamento, nome e qualificação dos
                instrutores, identificação do empregador e assinaturas do instrutor e do trabalhador, acrescido da assinatura
                do responsável pelo empregador. O certificado de participação no treinamento deve ser entregue ao
                trabalhador, arquivando-se uma cópia na empresa.
            </div>
            <div>
                Para efeito de fiscalização é essencial que existam registros relativos a todas as atividades de treinamento. Os
                registros devem conter informações do tipo:
            </div>
            <li>Nome e identificação;</li>
            <li>Setor;</li>
            <li>Data e duração do treinamento;</li>
            <li>Local do treinamento;</li>
            <li>Tipo de treinamento;</li>
            <li>Nome do curso;</li>
            <li>Número do certificado (se houver);</li>
            <li>Nome do instrutor;</li>
            <li>Nome do responsável pelo consórcio.</li>
            <div>Também é de extrema importância a manutenção da lista de presença.</div>
            <div>
                É válido, também, observar o próprio processo de integração pelo qual irão passar todos os novos funcionários
                gerais da empresa, abordando assuntos como: prevenção de acidentes e doenças do trabalho, ambiente de
                trabalho, conhecimentos específicos para o desempenho da função, instruções de trabalho, ordens de serviço,
                etc.).
            </div>
            <div>Entre outros treinamentos posteriores conforme demanda e cronograma de ação de cada empresa:</div>
            <div>- NR-05 – Treinamento de CIPA;</div>
            <div>- NR-06 – Treinamento de Equipamentos de Proteção Individual - EPI;</div>
            <div>- NR-07 – Treinamento de Primeiros Socorros;</div>
            <div>- NR-10 – Treinamento de Segurança em Instalações e Serviços em Eletricidade;</div>
            <div>- NR-12 - Treinamento de Segurança no Trabalho em Máquinas e Equipamentos;</div>
            <div>- NR-13 – Treinamento de Segurança Caldeiras, Vasos de Pressão e Tubulações;</div>
            <div>- NR-15 - Treinamento de para Atividades e Operações Insalubres;</div>
            <div>- NR-16 - Treinamento para Atividades e Operações Perigosas;</div>
            <div>- NR-17 – Treinamento de Ergonomia ou Apresentação da AET – Analise Ergonômica do Trabalho;</div>
            <div>- NR-18 – Treinamento de Condições e Meio Ambiente de Trabalho na Indústria da Construção;</div>
            <div>- NR-20 – Treinamento de Segurança e Saúde no Trabalho com Inflamáveis e Combustíveis;</div>
            <div>- NR-23 – Treinamento de Combate a Incêndio ou Formação de Brigada de Incêndio conforme NPT 017;</div>
            <div>- NR-33 – Treinamento de Segurança e Saúde no Trabalho em Espaços Confinados;</div>
            <div>- NR-35 – Treinamento para Trabalho em Altura; Entre outros.</div>
            <div className='tituloCap' data-new-page data-sum>10. AVALIAÇÃO DOS RISCOS AMBIENTAIS NO PGR</div>
            <div>
                Para elaboração do PGR, são considerados riscos ambientais os agentes físicos, químicos e biológicos que, em
                função de sua natureza, concentração ou intensidade e tempo de exposição, forem capazes de causar danos à
                saúde do trabalhador. A literatura técnica disponível sobre o assunto também considera como riscos relevantes,
                que podem estar presentes nos ambientes de trabalho, os riscos ergonômicos e de acidentes, os quais também
                avaliamos neste Programa:
            </div>
            <div>
                <b>Agentes Físicos:</b> São as diversas formas de energia a que possam estar expostos os trabalhadores. Devem ser
                considerados durante as avaliações, os agentes físicos que se apresentam nas seguintes formas de energia:
                Ruído; Vibração; Pressões Anormais; Temperaturas Extremas; Radiações Ionizantes; Radiações Não Ionizantes;
                Infrassom e Ultrassom.
            </div>
            <div>
                <b>Agentes Químicos:</b> São substâncias, compostos ou produtos que possam penetrar no organismo pela via
                respiratória, ou pela natureza da atividade de exposição possam ter contato através da pele ou serem
                absorvidos pelo organismo por ingestão, conforme abaixo: Poeiras; Fumos; Névoas; Neblina; Gases e Vapores.
            </div>
            <div>
                <b>Agentes Biológicos:</b> São os seguintes os agentes biológicos, que se apresentam nas formas de micro-organismos
                e parasitas infecciosos vivos e suas toxinas, tais como: Bactérias; Fungos; Bacilos; Parasitas; Protozoários e Vírus,
                entre outros.
            </div>
            <div>
                <b>Agentes Ergonômicos:</b> São definidos como agentes ergonômicos, qualquer fator que possa interferir nas
                características psicofisiológicas do trabalhador, causando desconforto ou afetando sua saúde. São exemplos de
                risco ergonômico: o esforço físico intenso, o levantamento e transporte manual de peso, a imposição de ritmos
                excessivos de trabalho, a monotonia e repetitividade, a exigência de posturas inadequadas de trabalho, dentre
                outras situações causadoras de stress físico e/ou psíquico. Para atendimento a esse item a empresa deverá
                elaborar o Programa de Ergonomia (PROERGO) e realizar as Análises Ergonômicas do Trabalho (A.E.T.) dos
                postos existentes.
            </div>
            <div>
                <b>Agentes Mecânicos / Acidentes:</b> São definidos como agentes mecânicos ou de acidentes, qualquer fator que
                coloque o trabalhador em situação vulnerável que possa afetar sua integridade e seu bem estar físico e psíquico.
                São exemplos de risco de acidentes: as máquinas e equipamentos sem proteção, a realização de trabalhos sem
                a utilização de EPI´s adequados, o choque e o arco elétrico, as probabilidades de incêndio e explosão, o arranjo
                físico inadequado, ferramentas inadequadas ou defeituosas, animais peçonhentos, dentre outros.
            </div>
            <div className='tituloCap' data-new-page data-sum>11. ESTRUTURA DO PGR</div>
            <div>
                A metodologia adotada para elaboração do PGR, foi baseada na NR 1.5.7.1, que estabelece como estrutura
                mínima do PGR, os seguintes documentos:
            </div>
            <div>
                a) inventário de riscos; e
            </div>
            <div>
                b) plano de ação.
            </div>
            <div style={{ marginTop: '40px' }}>
                <b style={{ textDecoration: 'underline' }}>
                    INVENTÁRIO DE RISCOS
                </b>
            </div>
            <div style={{ marginTop: '40px' }}>
                Integram o inventário de riscos os seguintes elementos estruturais:
            </div>
            <div style={{ marginTop: '40px' }}>
                <b>Atividade:</b> deve ser preenchida sempre tendo como ponto inicial as atividades que são realizadas no setor, de
                forma mais detalhada possível, evitando assim a descrição de atividades macro e a possibilidade de que algum
                risco não seja avaliado. Levar em consideração as atividades rotineiras e não rotineiras executadas no setor,
                além daquelas eventualmente realizadas fora dos ambientes normais de trabalho do setor ou com terceiros.
            </div>
            <div>
                <b>Risco:</b> o risco surge quando da interação entre o empregado e o perigo, onde o risco efetivamente vai gerar,
                caso consiga atingir o empregado, a lesão o agravo à saúde. Exemplos: choque elétrico, queda, atropelamento,
                colisão, agressão física, impacto, postura inadequada. O risco também é chamado de risco inerente, para efeito
                de estudos do risco residual.
            </div>
            <div>
                <b>Lesões ou agravos à saúde:</b> fatores que podem trazer prejuízo à integridade física, de saúde e mental do
                empregado.
            </div>
            <div>
                <b>Grupo Homogêneo de Exposição (GHE): </b>corresponde a um grupo de trabalhadores, que realizam <span style={{ textDecoration: 'underline' }}>atividades e
                    experimentam exposição a agentes ambientais semelhantes,</span> de forma que o resultado fornecido pela avaliação
                da exposição de qualquer trabalhador do grupo seja representativo da exposição do restante dos trabalhadores
                do mesmo grupo. A partir de um estudo integrado de três vertentes: os ambientes de trabalho, os trabalhadores
                expostos e os agentes ambientais, é possível definir a unidade de trabalho, chamada GHE.
            </div>
            <div>
                Classificação do risco: produto da severidade e da probabilidade do risco. R = S x P. A Matriz Qualitativa de
                Riscos e a classificação do nível de gradação da Probabilidade e da Severidade são apresentadas nas tabelas
                abaixo.
            </div>

            <div className='table-div matriz'>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Severidade</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Baixa(1)</div>
                    <div className='table-td '>Média (2)</div>
                    <div className='table-td '>Alta(3)</div>
                    <div className='table-td '>Muito Alta(4)</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Muito Alta(4)</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Alto</div>
                    <div className='table-td' >Muito alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Alta(3)</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Alto</div>
                    <div className='table-td' >Alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Média(2)</div>
                    <div className='table-td' >Leve</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Baixa(1)</div>
                    <div className='table-td' >Leve</div>
                    <div className='table-td' >Leve</div>
                    <div className='table-td' >Médio</div>
                    <div className='table-td' >Médio</div>
                </div>
            </div>

            <div><b>Probabilidade:</b> chance de o risco atingir o empregado.</div>
            <div className='table-div prob'>
                <div className='table-tr'>
                    <div className='table-td '>Probabilidade</div>
                    <div className='table-td '>Muito Alta</div>
                    <div className='table-td'>É certo que o risco irá atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Probabilidade</div>
                    <div className='table-td '> Alta</div>
                    <div className='table-td'>É provável que o risco irá atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Probabilidade</div>
                    <div className='table-td '>Média</div>
                    <div className='table-td'>Existe uma pequena chance de o risco atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Probabilidade</div>
                    <div className='table-td '>Baixa</div>
                    <div className='table-td'>É improvável que o risco irá atingir o empregado, mas pode ocorrer.</div>
                </div>
            </div>

            <div><b>Severidade:</b> representa as lesões ou agravos à saúde decorrentes do risco, caso este venha a atingir o empregado.</div>
            <div className='table-div prob'>
                <div className='table-tr'>
                    <div className='table-td '>Severidade</div>
                    <div className='table-td '>Muito Alta</div>
                    <div className='table-td'>Mais de uma morte e/ ou lesão grave. Acidente ampliado*</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Severidade</div>
                    <div className='table-td '>Alta</div>
                    <div className='table-td'>Lesões graves e/ou incapacitantes.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Severidade</div>
                    <div className='table-td '>Média</div>
                    <div className='table-td'>Lesão ou agravo à saúde com afastamento.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Severidade</div>
                    <div className='table-td '>Baixa</div>
                    <div className='table-td'>Lesão ou agravo à saúde leve ou sem afastamento.</div>
                </div>
            </div>
            <div>
                *Acidente ampliado é aquele com maior gravidade, com suas consequências se estendendo a um número maior
                de pessoas, além dos trabalhadores, atingindo inclusive a população.
            </div>
            <div>
                <b>Risco residual:</b> é aquele que, mesmo após tomadas todas as medidas de prevenção frente ao risco inerente,
                ainda se encontra presente no ambiente de trabalho, sendo este relativo ao risco inerente ou não. Caso ainda
                persista um risco residual após a implantação das medidas de prevenção, este deve ser acompanhado durante
                a execução das atividades, buscando detectar suas causas e levantamento da possibilidade de estabelecer novas
                medidas visando seu controle ou eliminação.
            </div>
            <div data-new-page style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }} >
                <b>CLASSIFICAÇÃO DO RISCO = PROBABILIDADE X SEVERIDADE</b>
            </div>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <b>1 - MATRIZ ORIGINAL</b>
            </div>
            <div className='table-div matriz'>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Severidade</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Baixa(1)</div>
                    <div className='table-td '>Média (2)</div>
                    <div className='table-td '>Alta(3)</div>
                    <div className='table-td '>Muito Alta(4)</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Muito Alta(4)</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto</div>
                    <div className='table-td' style={{ backgroundColor: '#E42B2B' }}>Muito alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Alta(3)</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Média(2)</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Baixa(1)</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio</div>
                </div>
            </div>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <b>2 - INTERPRETAÇÃO DA MATRIZ </b>
            </div>
            <div className='table-div matriz'>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Severidade</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td '>Matriz Qualitativa de Riscos</div>
                    <div className='table-td '>Baixa(S1)</div>
                    <div className='table-td '>Média (S2)</div>
                    <div className='table-td '>Alta(S3)</div>
                    <div className='table-td '>Muito Alta(S4)</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Muito Alta(P4)</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P4 x S1</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P4 x S2</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto: P4 x S3</div>
                    <div className='table-td' style={{ backgroundColor: '#E42B2B' }}>Muito alto: P4 x S4</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Alta(P3)</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P3 x S1</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P3 x S2</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto: P3 x S3</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto: P3 x S4</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Média(P2)</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve: P2 x S1</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P2 x S2</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P2 x S3</div>
                    <div className='table-td' style={{ backgroundColor: '#D55757' }}>Alto: P2 x S4</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' >Probabilidade</div>
                    <div className='table-td '>Baixa(P1)</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve: P1 x S1</div>
                    <div className='table-td' style={{ backgroundColor: '#CCFF99' }}>Leve: P1 x S2</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P1 x S3</div>
                    <div className='table-td' style={{ backgroundColor: '#FFFFCC' }}>Médio: P1 x S4</div>
                </div>
            </div>
            <div data-new-page style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={probabilidade} style={{ width: '50%' }} />
            </div>
            <div data-new-page style={{ display: 'flex', justifyContent: 'center', marginTop: '90px', marginBottom: '20px' }} >
                <b>CLASSIFICAÇÃO DO RISCO = PROBABILIDADE X SEVERIDADE</b>
            </div>

            <div className='table-div prob2'>
                <div className='table-tr'>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}><b style={{ textDecoration: 'underline' }}>Probabilidade: chance</b> de o risco atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Muito Alta (<b>P4</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>É <b style={{ textDecoration: 'underline' }}>certo</b> que o risco irá atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}> Alta (<b style={{ textDecoration: 'underline' }}>P3</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>É <b style={{ textDecoration: 'underline' }}>provável</b> que o risco irá atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Média (<b style={{ textDecoration: 'underline' }}>P2</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>Existe uma <b style={{ textDecoration: 'underline' }}>pequena chance</b> de o risco atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Baixa (<b style={{ textDecoration: 'underline' }}>P1</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>É <b style={{ textDecoration: 'underline' }}>improvável</b> que o risco irá atingir o empregado, <b style={{ textDecoration: 'underline' }}>mas pode ocorrer.</b></div>
                </div>
            </div>
            <div className='table-div prob2' style={{ marginTop: '20px' }}>
                <div className='table-tr'>
                    <div className='table-td'><b style={{ textDecoration: 'underline' }}>2) SEVERIDADE:</b> representa as <b style={{ textDecoration: 'underline' }}>lesões ou agravos</b> à saúde decorrentes do risco, caso este venha a atingir o empregado.</div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Muito Alta (<b>P4</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>Mais de uma <b style={{ textDecoration: 'underline' }}>morte</b> e/ ou lesão <b style={{ textDecoration: 'underline' }}>grave.</b> <b style={{ textDecoration: 'underline' }}>Acidente ampliado*</b> </div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}> Alta (<b style={{ textDecoration: 'underline' }}>P3</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>Lesões <b style={{ textDecoration: 'underline' }}>graves</b> e/ou <b style={{ textDecoration: 'underline' }}>incapacitantes.</b> </div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Média (<b style={{ textDecoration: 'underline' }}>P2</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>Lesão ou agravo à saúde <b style={{ textDecoration: 'underline' }}>com afastamento.</b></div>
                </div>
                <div className='table-tr'>
                    <div className='table-td ' style={{ display: 'flex', justifyContent: 'flex-end' }}>Baixa (<b style={{ textDecoration: 'underline' }}>P1</b>)</div>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>Lesão ou agravo à saúde <b style={{ textDecoration: 'underline' }}>leve</b> ou <b style={{ textDecoration: 'underline' }}>sem afastamento.</b> </div>
                </div>
                <div className='table-tr'>
                    <div className='table-td' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                        *Acidente ampliado é aquele com maior gravidade, com suas consequências se estendendo a um número maior de pessoas, além dos trabalhadores, atingindo inclusive a população.
                    </div>
                </div>
            </div>
            <div data-new-page><b style={{ textDecoration: 'underline' }}>PLANO DE AÇÃO</b></div>
            <div>
                Para cada medida de prevenção elencada deverá ser estabelecido um plano de ação, visando o
                acompanhamento de sua efetividade.
            </div>
            <div style={{ marginTop: '30px' }}>Conforme NR 1.5.5.2. Dos Planos de Ação:</div>
            <div>
                1.5.5.2.1 A organização deve elaborar plano de ação, indicando as medidas de prevenção a serem introduzidas,
                aprimoradas ou mantidas, conforme o subitem 1.5.4.4.5.
            </div>
            <div>
                1.5.5.2.2 Para as medidas de prevenção deve ser definido cronograma, formas de acompanhamento e aferição
                de resultados.
            </div>
            <div>
                1.5.5.3 Implementação e acompanhamento das medidas de prevenção.
            </div>
            <div>
                1.5.5.3.1 A implementação das medidas de prevenção e respectivos ajustes devem ser registrados.
            </div>
            <div>
                1.5.5.3.2 O desempenho das medidas de prevenção deve ser acompanhado de forma planejada e contemplar:
            </div>
            <div>
                a) a verificação da execução das ações planejadas;
            </div>
            <div>
                b) as inspeções dos locais e equipamentos de trabalho; e
            </div>
            <div>
                c) o monitoramento das condições ambientais e exposições a agentes nocivos, quando aplicável.
            </div>
            <div>
                <b>Medidas de prevenção: </b>o conjunto medidas tomadas em todas as fases da atividade da organização, visando
                evitar, eliminar, minimizar ou controlar os riscos ocupacionais. Ex.: EPI, EPC, Apr, DDS, treinamento, aspectos
                comportamentais. Importante: ao estabelecer as medidas de prevenção, deve-se levar em conta a hierarquia
                das medidas de prevenção de riscos prevista no item 1.4.1.g da NR 1: eliminação (E), coletiva(C),
                administrativa(A) e individual(I).
            </div>
            <div><b>Cronograma (prazo):</b> prazo para o cumprimento a ação ligada à medida de prevenção.</div>
            <div>
                <b>Formas de Acompanhamento:</b> meios utilizados para avaliar a eficácia da medida de prevenção.
                Inspeções de segurança: verificações nas atividades executadas.
                Acidentes: ocorrências que geraram lesões, doenças ou fatalidades.
                Quase-acidentes: ocorrências que não geraram lesões nos empregados.
                Comunicação: relatos por parte dos empregados em relação à eficácia das medidas de prevenção.
            </div>
            <div>
                <b>Aferição dos resultados:</b> acompanhamento do desempenho das medidas de prevenção conforme a realização
                das atividades e ocorrências ligadas às formas de acompanhamento definidas.
            </div>
            <div className='tituloCap' data-new-page data-sum>12. REGISTRO, MANUTENÇÃO E DIVULGAÇÃO DO PGR</div>
            <div>
                A avaliação de riscos do PGR deve constituir um processo contínuo e ser revista a cada dois anos ou quando da
                ocorrência das seguintes situações:
            </div>
            <div style={{ marginLeft: '20px' }}>
                <div>
                    a. após implementação das medidas de prevenção, para avaliação de riscos residuais;
                </div>
                <div>
                    b. após inovações e modificações nas tecnologias, ambientes, processos, condições, procedimentos e
                    organização do trabalho que impliquem em novos riscos ou modifiquem os riscos existentes;
                </div>
                <div>
                    c. quando identificadas inadequações, insuficiências ou ineficácias das medidas de prevenção;
                </div>
                <div>
                    d. na ocorrência de acidentes ou doenças relacionadas ao trabalho;
                </div>
                <div>
                    e. quando houver mudança nos requisitos legais aplicáveis.
                </div>
            </div>
            <div>
                No caso de organizações que possuírem certificações em sistema de gestão de SST, o prazo poderá ser de até 3
                (três) anos.
            </div>
            <div>
                O PGR pode ser apresentado à CIPA – Comissão Interna de Prevenção de Acidentes e discutido durante suas
                reuniões. A divulgação dos dados deste PGR pode ser feita de diversas maneiras dependendo do porte do
                estabelecimento. Porém, devido às características das atividades da empresa acredita-se que a melhor maneira,
                seria repassar o conteúdo deste Programa através de reuniões setoriais, reuniões da CIPA, etc.
            </div>
            <div>
                O Cronograma, Forma de acompanhamento e Aferição de resultados estão previstos no Inventário de Riscos,
            </div>
            {
                uniqueGHEs.map((ghe: any, index: number) => (
                    <div className='table-div inventario' data-landscape="true">
                        {index === 0 && (
                            <>
                                <div className='tituloCap' data-sum>13. PROGRAMA DE GERENCIAMENTO DE RISCOS/INVENTÁRIO DE RISCOS</div>
                                <div style={{ marginBottom: '10px' }}>A seguir é apresentado o Programa de Gerenciamento de Riscos.</div>
                            </>
                        )}
                        <div className="table-tr head" style={{ borderTop: index === 0 ? "1px solid #000" : "" }}>
                            <div className='table-td th'>EMPRESA</div>
                            <div className='table-td'>{empresaRazaoSocial}</div>
                            <div className='table-td th'>HORÁRIO DE TRABALHO</div>
                            <div className='table-td'>Conforme item 3.1 deste documento</div>
                        </div>

                        <div className="table-tr head">
                            <div className='table-td th'>GHE</div>
                            <div className='table-td'>{ghe.nome}</div>
                            <div className='table-td th'>HORÁRIO DE TRABALHO</div>
                            <div className='table-td'>Conforme item 3.1 deste documento</div>
                        </div>

                        {renderizarFuncoes(agruparFuncoesPorGHE(ghe.id))}

                        {/* Retirado por solicitação do Doutor - 25/10/2024 */}
                        {/* <div className="table-tr note">
                            <div className='table-td th'>NOTA: OS RISCOS ERGONÔMICOS DEVERÃO SER RECONHECIDOS ATRAVÉS DE AEP - AVALIAÇÃO ERGONÔMICA PRELIMINAR, APÓS 6 MESES DA ELABORAÇÃO DO PGR </div>
                        </div> */}
                        <RenderizarRiscos gheId={ghe.id} />
                    </div>
                ))
            }


            <div className='tituloCap' data-new-page data-sum>14. MEDIDAS DE PREVENÇÃO (1.5.5.1)</div>
            <div className='tituloCap' data-sum>14.1. DETERMINAÇÃO DAS MEDIDAS DE PREVENÇÃO (CONTROLE)</div>
            <div>
                São adotadas medidas de prevenção para eliminar, reduzir ou controlar os riscos sempre que:
            </div>
            <div>a) exigências previstas em Normas Regulamentadoras e nos dispositivos legais determinarem;</div>
            <div>b) a classificação dos riscos ocupacionais assim determinar, conforme subitem 1.5.4.4.5 da NR 1;</div>
            <div>
                c) houver evidências de associação, por meio do controle médico da saúde, entre as lesões e os agravos à
                saúde dos trabalhadores com os riscos e as situações de trabalho identificados.
            </div>
            <div>
                Quando comprovada pela organização a inviabilidade técnica da adoção de medidas de proteção coletiva, ou
                quando estas não forem suficientes ou encontrarem-se em fase de estudo, planejamento ou implantação ou,
                ainda, em caráter complementar ou emergencial, deverão ser adotadas outras medidas, obedecendo-se a
                seguinte hierarquia:
            </div>
            <div>a) medidas de caráter administrativo ou de organização do trabalho;</div>
            <div>b) utilização de equipamento de proteção individual - EPI.</div>
            <div>
                A implantação de medidas de prevenção deverá ser acompanhada de informação aos trabalhadores quanto
                aos procedimentos a serem adotados e limitações das medidas de prevenção.
            </div>
            <div className='tituloCap' data-sum>14.2. AVALIAÇÃO DA EFICÁCIA DAS MEDIDAS DE CONTROLE (CRONOGRAMA)/RISCO RESIDUAL</div>
            <div>Está especificado no Item 13, que trata do PROGRAMA DE GERENCIAMENTO DE RISCOS/INVENTÁRIO DE RISCOS.</div>
            <div className='tituloCap' data-sum>14.3. ESTABELECIMENTO DE MEDIDAS DE PROTEÇÃO COLETIVAS</div>
            <div>
                São adotadas pela {empresaRazaoSocial}, todas as medidas de proteção coletiva possíveis, entretanto quando
                estas não forem suficientes ou encontrarem-se em fase de estudo, planejamento ou implantação ou, ainda, em
                caráter complementar ou emergencial, deverão ser adotadas outras medidas, obedecendo-se a seguinte
                hierarquia:
            </div>
            <div>a) medidas de caráter administrativo ou de organização do trabalho;</div>
            <div>b) utilização de equipamento de proteção individual - EPI</div>
            <div className='tituloCap' data-sum>14.4. ESTABELECIMENTO DAS MEDIDAS DE PROTEÇÃO INDIVIDUAIS </div>
            <div className='table-div'>
                <div className='table-tr'>
                    <div className='table-td th'>
                        EQUIPAMENTOS DE PROTEÇÃO INDIVIDUAL
                    </div>
                </div>

                {riscos && riscos.length > 0 ? (
                    riscos.map((risco: any) => (
                        risco.epi ? ( // Verifica se risco.epi tem um valor verdadeiro (não vazio e definido)
                            <div key={`risco-${risco.id}`} className='table-tr'>
                                <div className='table-td'>
                                    {risco.epi}
                                </div>
                            </div>
                        ) : (
                            <div key={`risco-${risco.id}`} className='table-tr'>
                                <div className='table-td' style={{ textAlign: 'center' }}>
                                    Não há EPIs para serem listados
                                </div>
                            </div>
                        )
                    ))
                ) : (
                    <div className='table-tr'>
                        <div className='table-td' style={{ textAlign: 'center' }}>
                            Não há EPIs para serem listados
                        </div>
                    </div>
                )}


            </div>
            <div className='table-div cronograma' data-landscape>
                <div className='tituloCap' data-sum>15. CRONOGRAMA DO PLANO DE AÇÃO</div>
                <div className='table-tr ' style={{ borderTop: '1px solid #000' }}>
                    <div className='table-td th'>Item</div>
                    <div className='table-td th'>Ação Planejada</div>
                    {intervalosCronograma.map((intervalo: any, index) => (
                        <div key={index} className='table-td th'>
                            {formatarIntervaloExecucoes(intervalo.intervalo_execucoes)}
                        </div>
                    ))}
                    <div className='table-td th'>Data de Execução</div>
                    <div className='table-td th'>Responsável</div>
                </div>
                {acoesCronograma.map((acao: any) => (
                    acao.descricao ? (
                        <>
                            <div className='table-tr'>
                                <div className='table-td'>Programado</div>
                                <div className='table-td'>{acao.descricao}</div>
                                {acao.execucoes.map((intervalo: any, index: any) => (
                                    <div key={index} className='table-td'>
                                        {acao.execucoes.find((e: any) => e.id === intervalo.id && e.executada) ? "X" : ""}
                                    </div>
                                ))}
                                <div className='table-td'> {acao.data_inicial ? formatarDataISO(acao.data_inicial) : ''}</div>
                                <div className='table-td'>{acao.responsavel}</div>
                            </div>

                            <div className='table-tr'>
                                <div className='table-td'>Realizado</div>
                                <div className='table-td'>{acao.descricao}</div>
                                {acao.execucoes.map((intervalo: any, index: any) => (
                                    <div key={index} className='table-td'>
                                    </div>
                                ))}
                                <div className='table-td'></div>
                                <div className='table-td'>{acao.responsavel}</div>

                            </div>
                        </>
                    ) : (
                        <>
                            <div className='table-tr'>
                                <div className='table-td'>Não há dados para serem apresentados</div>
                            </div>
                        </>
                    )

                ))}

            </div>

            <div className='tituloCap' data-sum>15.1. VERIFICAÇÃO DE EXECUÇÃO DE TAREFAS/ INSPEÇÕES NO LOCAL DE TRABALHO/ AVALIAÇÕES DE AGENTES AMBIENTAIS </div>
            <div>Conforme Cronograma do Plano de Ação.</div>
            <div className='tituloCap' data-sum>15.2. AVALIAÇÕES QUANTITATIVAS, DATA E UNIDADE DE MEDIDA DOS AGENTES AVALIADOS</div>
            <div>
                Será estabelecido no Cronograma do Plano de Ação, a elaboração do LTCAT, que é o documento hábil para
                serem lançadas as medições dos agentes ambientais possíveis de mensuração.
            </div>
            <div className='tituloCap' data-sum>15.3. CORREÇÕES QUANDO APURADO INEFICÁCIA</div>
            <div>
                Conforme Item 4.2.1.2 as revisões antecipadas se darão conforme análise técnica da situação apresentada no
                caso de ter sido apurado alguma ineficácia do Plano de Ação e poderão ser feitas a qualquer momento.
            </div>
            <div className='tituloCap' data-new-page data-sum>16. ENCERRAMENTO</div>
            <div>
                O presente Relatório Técnico é composto por folhas numeradas mecanicamente, acrescidas da página de rosto,
                do índice e mais anexo, e se constitui em um documento técnico a ser interpretado de modo conjunto,
                complementar e iterativo entre todos os seus elementos.
            </div>
            <div>
                A caracterização é válida enquanto as condições de trabalho permanecer como aquelas observadas e/ou
                informadas durante o levantamento ambiental e restringe-se exclusivamente as avaliações e recomendações
                realizadas, ficando sob inteira responsabilidade da <span className='bold'>{empresaRazaoSocial}</span>, a implantação, implementação e
                acompanhamento das medidas aqui propostas.
            </div>

            {
                historicoData.map((item) => {
                    // Converter a data de criação para o objeto Date
                    const dataRevisao = new Date(item.revisao.created_at);

                    // Formatar a data no estilo "03 de Janeiro de 2024"
                    const dataFormatada = dataRevisao.toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                    });


                    if (!datasExibidas.has(dataFormatada)) {
                        // Adicionar a data formatada ao conjunto de datas exibidas
                        setDatasExibidas(new Set(datasExibidas).add(dataFormatada));

                        return (
                            <div key={item.id} style={{ margin: '0 auto', marginTop: '20px', width: 'fit-content' }}>
                                {dataFormatada} – Revisão 0{uniqueRevisoes.get(item.revisao.id)}.
                            </div>
                        );
                    }
                })
            }


            <div style={{ margin: '0 auto', paddingTop: '5px', marginTop: '120px', width: '350px', borderTop: '1px solid #000', textAlign: 'center' }}>{nomeResponsavel}</div>
            <div style={{ margin: '0 auto', marginTop: '5px', width: 'fit-content' }}>{cargoResponsavel}</div>
            <div style={{ margin: '0 auto', marginTop: '5px', width: 'fit-content' }}>{crmResponsavel} {registroResponsavel}</div>
            <hr></hr>
            <div style={{ marginTop: '80px', width: 'fit-content' }}>Responsável pela <span className='bold'>({empresaRazaoSocial})</span> pela implementação do PGR</div>
            <div className='tituloCap' data-new-page data-sum>17. BIBLIOGRAFIA</div>
            <div>Portaria n° 3.214 de 08 de junho de 1978 (Normas Regulamentadoras).</div>
            <div>Portaria SEPRT n.º 6.730, de 09 de março de 2020.</div>
            <div className='tituloCap' data-new-page data-sum>18. DEFINIÇÕES E SIGLAS</div>
            <div>ABNT: Associação Brasileira de Normas Técnicas;</div>
            <div>
                Ação Corretiva: Ação para eliminar a causa de uma não-conformidade (anomalia) identificada ou outra situação
                indesejável;
            </div>
            <div>
                Ação Mitigadora: Ação implementada para controlar ou reduzir o impacto de uma anomalia. Inclui o controle
                de produtos não-conformes, visando prevenir sua utilização ou instalação não intencional;

            </div>
            <div>
                Ação Preventiva: Ação para eliminar a causa de uma potencial não-conformidade (anomalia) identificada ou
                outra situação potencialmente indesejável;

            </div>
            <div>
                Acidente: ocorrência que gerara lesões, doenças ou fatalidades. Evento imprevisto e indesejável, instantâneo
                ou não, que resultou em dano à pessoa (inclui a doença do trabalho e a doença profissional), ao patrimônio
                (próprio ou de terceiros) ou impacto ao meio ambiente. Nota: Segundo a legislação brasileira (Lei 8.213/98), as
                doenças ocupacionais estão incluídas no conceito de acidente do trabalho;
            </div>
            <div>
                Acidente ampliado é aquele com maior gravidade, com suas consequências se estendendo a um número maior
                de pessoas, além dos trabalhadores, atingindo inclusive a população.
            </div>
            <div>
                Anomalia: Situação ou evento indesejável que resulte ou que possa resultar em danos ou falhas que afetem
                pessoas, o meio ambiente, o patrimônio (próprio ou de terceiros), os produtos ou os processos produtivos;
                AET: Análise Ergonômica do Trabalho;
            </div>
            <div>
                Aferição dos resultados: acompanhamento do desempenho das medidas de prevenção conforme a realização
                das atividades e ocorrências ligadas às formas de acompanhamento definidas.

            </div>
            <div>APR: Análise Preliminar de Riscos;</div>
            <div>
                Auditoria comportamental: Método de observação e interação com a força de trabalho, com foco na atitude e
                no comportamento das pessoas durante a realização de suas tarefas, através de uma técnica de abordagem
                positiva e focando na conscientização e na melhoria contínua do desempenho em SMS da força de trabalho;
            </div>
            <div>CAT: Comunicação de Acidente de Trabalho;</div>
            <div>
                CIPA: Comissão Interna de Prevenção de Acidentes;
            </div>
            <div>
                CIPATR: Comissão Interna de Prevenção de Acidentes do Trabalho Rural
            </div>
            <div>
                Classificação do risco: produto da severidade e da probabilidade do risco. R = S x P.
            </div>
            <div>
                CNAE: Código Nacional de Atividade Econômica;
            </div>
            <div>
                CNPJ: Cadastro Nacional de Pessoa Jurídica;

            </div>
            <div>
                Cronograma (prazo): prazo para o cumprimento a ação ligada à medida de prevenção.
            </div>
            <div>
                Comunicação: relatos por parte dos empregados em relação à eficácia das medidas de prevenção.
            </div>
            <div>
                CTPP: Comissão Tripartite Paritária Permanente;
            </div>
            <div>
                DDS: Diálogo Diário de Segurança;
            </div>
            <div>
                DS: Diálogo de Segurança;
            </div>
            <div>
                DSS: Diálogo de Segurança e Saúde;

            </div>
            <div>
                DSMS: Diálogo de Segurança, Meio Ambiente e Saúde;
            </div>
            <div>
                Desvio: Qualquer ação ou condição, que tem potencial para conduzir, direta ou indiretamente, a danos a
                pessoas, ao patrimônio (próprio ou de terceiros) ou impacto ao meio ambiente, que se encontra desconforme
                com as normas de trabalho, procedimentos, requisitos legais ou normativos, requisitos do sistema de gestão ou
                boas práticas;
            </div>
            <div>
                DORT: Doença Osteomuscular Relacionada ao Trabalho;
            </div>
            <div>
                Empregador: conforme a NR 1, considera-se empregador, a empresa, individual ou coletiva, que assumindo os
                riscos da atividade econômica, admite, assalaria e dirige a prestação pessoal de serviços;

            </div>
            <div>
                EPI: Equipamento de Proteção Individual;
            </div>
            <div>
                EPC: Equipamento de Proteção Coletiva;

            </div>
            <div>
                FISPQ: Ficha de Informação de Segurança de Produtos Químicos;
            </div>
            <div>
                GET: Grupo de Estudos Tripartite;
            </div>
            <div>
                GHE: Grupo Homogêneo de Exposição, corresponde a um grupo de trabalhadores, que realizam atividades e
                experimentam exposição a agentes ambientais semelhantes, de forma que o resultado fornecido pela avaliação
                da exposição de qualquer trabalhador do grupo seja representativo da exposição do restante dos trabalhadores
                do mesmo grupo. A partir de um estudo integrado de três vertentes: os ambientes de trabalho, os trabalhadores
                expostos e os agentes ambientais, é possível definir a unidade de trabalho, chamada GHE.

            </div>
            <div>
                Inspeções de segurança: verificações nas atividades executadas.
            </div>
            <div>
                IN: Instrução Normativa;
            </div>
            <div>
                Incidente: Evento relacionado ao trabalho no qual uma lesão ou doença ou fatalidade ocorreu ou poderia
                ocorrer;
            </div>
            <div>
                LER: Lesões por Esforços Repetitivos;
            </div>
            <div>
                Limite de Tolerância (LT): Concentração ou intensidade máxima ou mínima, relacionada com a natureza e o
                tempo de exposição ao agente, que não causará dano à saúde do trabalhador, durante a sua vida laboral;
                ME: Ministério da Economia;
            </div>
            <div>
                Medidas de prevenção: o conjunto medidas tomadas em todas as fases da atividade da organização, visando evitar, eliminar,
                minimizar ou controlar os riscos ocupacionais. Ex.: EPI, EPC, Apr, DDS, treinamento, aspectos
                comportamentais. Importante: ao estabelecer as medidas de prevenção, deve-se levar em conta a hierarquia
                das medidas de prevenção de riscos prevista no item 1.4.1.g da NR 1: eliminação(E), coletiva(C),
                administrativa(A) e individual(I).
            </div>
            <div>
                NIOSH: National Institute of Occupational Safety and Health;
            </div>
            <div>
                Nível de Ação: Valor equivalente a 50% da DOSE para ruído e metade do LT para agentes químicos a partir do
                qual devem ser iniciadas medidas preventivas de forma a controlar a probabilidade de que as exposições a
                agentes ambientais possam prejudicar a saúde do trabalhador;

            </div>
            <div>
                Não-Conformidade: Não atendimento a um requisito;
            </div>
            <div>
                NBR: Norma Brasileira;
            </div>
            <div>
                NPS: Nível de Pressão Sonora;
            </div>
            <div>
                NR: Norma Regulamentadora (Secretaria do Trabalho do Ministério da Economia);

            </div>
            <div>
                PA: Permissão de Acesso;
            </div>
            <div>
                PCA: Programa de Conservação Auditiva;
            </div>
            <div>
                PEL: Plano de Emergência Local;
            </div>
            <div>
                Perigo: fonte com o potencial de causar lesões ou agravos à saúde. Elemento que isoladamente ou em
                combinação com outros tem o potencial dar origem a lesões ou agravos à saúde. PGRSS: Plano de
                Gerenciamento de Resíduos de Serviços de Saúde
            </div>
            <div>
                PNOC: Para as poeiras ou material particulado que são insolúveis ou de baixa solubilidade a ACGIH define como
                "PNOC_. Traduzido para o português como "Partículas não Especificadas de Outra Maneira. Os PNOS são
                matérias que não devem conter asbesto em sua composição; a porcentagem de sílica deve ser inferior a 1%; os
                valores de referência servem como referência para avaliação da jornada de trabalho, no entanto, não devem
                ser utilizados para exposições de curta duração com valores altos de concentração ambiental; e Não devem ser
                aplicados para substâncias que causam alterações fisiológicas a baixas concentrações.
            </div>
            <div>
                PGR: Programa de Gerenciamento de Riscos
            </div>
            <div>
                PPR: Programa de Proteção Respiratória;

            </div>
            <div>
                Probabilidade: chance de o risco atingir o empregado.

            </div>
            <div>
                PROERGO: Programa de Ergonomia;
            </div>
            <div>
                PT: Permissão para Trabalho;
            </div>
            <div>
                RBC: Rede Brasileira de Calibração;
            </div>
            <div>
                Quase-acidentes: ocorrências que não geraram lesões nos empregados.
            </div>
            <div>
                Risco: o risco surge quando da interação entre o empregado e o perigo, onde o risco efetivamente vai gerar,
                caso consiga atingir o empregado, a lesão o agravo à saúde.
            </div>
            <div>
                Risco residual: é aquele que, mesmo após tomadas todas as medidas de prevenção frente ao risco inerente,
                ainda se encontra presente no ambiente de trabalho, sendo este relativo ao risco inerente ou não. Caso ainda
                persista um risco residual após a implantação das medidas de prevenção, este deve ser acompanhado durante
                a execução das atividades, buscando detectar suas causas e levantamento da possibilidade de estabelecer novas
                medidas visando seu controle ou eliminação.

            </div>
            <div>
                SESTR: Serviço Especializado em Segurança e Saúde no Trabalho Rural;
            </div>
            <div>
                Severidade: representa as lesões ou agravos à saúde decorrentes do risco, caso este venha a atingir o
                empregado.
            </div>
            <div>
                SESMT: Serviço Especializado em Engenharia de Segurança e em Medicina do Trabalho;
            </div>
            <div>
                SIPAT: Semana Interna de Prevenção de Acidentes do Trabalho;

            </div>
            <div>
                SPDA: Sistema de Proteção contra Descargas Atmosféricas;

            </div>
            <div>
                SST: Segurança e Saúde no Trabalho.
            </div>






        </>
    );
}
